export default {
  ' = Equal to': ' = Equal to',
  '# of Articles': '# of Articles',
  '# of Followers': '# of Followers',
  '# of Hours Watched': '# of Hours Watched',
  '# of Influencers': '# of Influencers',
  '# of Mentions': '# of Mentions',
  '# of Selected Positive Reviews': '# of Selected Positive Reviews',
  '# of Video Engagement': '# of Video Engagement',
  '#PUBGMID2025Creator': '#PUBGMID2025Creator',
  '#PUBGMIDJadiCreator2025': '#PUBGMIDJadiCreator2025',
  '#PUBGMOBILEMMM2025Creator': '#PUBGMOBILEMMM2025Creator',
  '#PUBGMTH2025Creator': '#PUBGMTH2025Creator',
  '% of Official Content': '% of Official Content',
  '% of UGC Content': '% of UGC Content',
  '(Available for YouTube videos with subtitles only.)': '(Available for YouTube videos with subtitles only.)',
  '(Chart Interaction: Report Type → Subtopic → Keyword) Click a line to filter linked subtopics and keywords':
    '(Chart Interaction: Report Type → Subtopic → Keyword) Click a line to filter linked subtopics and keywords',
  '(Expected to wait for 0.5h ~ 4h)': '(Expected to wait for 0.5h ~ 4h)',
  '(Only supports videos from certain channels)': '(Only supports videos from certain channels)',
  '(Refreshed Every 30 Mins)': '(Refreshed Every 30 Mins)',
  '(Remaining system uses today: {remainder}/{total})': '(Remaining system uses today: {remainder}/{total})',
  '(Top 100)': '(Top 100)',
  '(case-insensitive)': '(case-insensitive)',
  '(hours)': '(hours)',
  '({start_time} to {end_time})': '({start_time} to {end_time})',
  '-': '-',
  '/': '/',
  '0 ~ 5 people': '0 ~ 5 people',
  '1 Star Reviews': '1 Star Reviews',
  '1. The crawler is unable to retrieve the necessary content for a summary from this link':
    '1. The crawler is unable to retrieve the necessary content for a summary from this link',
  '1.5 Years Summary': '1.5 Years Summary',
  '10 ~ 20 people': '10 ~ 20 people',
  '1K+': '1K+',
  '2 Star Reviews': '2 Star Reviews',
  '2. Gemini API is unstable': '2. Gemini API is unstable',
  '3 Star Reviews': '3 Star Reviews',
  '30-Day Positive %': '30-Day Positive %',
  '4 Star Reviews': '4 Star Reviews',
  '5 Star Reviews': '5 Star Reviews',
  '5 ~ 10 people': '5 ~ 10 people',
  '< Less than': '< Less than',
  '> 20 people': '> 20 people',
  '> Greater than': '> Greater than',
  'A page with the same name already exists.': 'A page with the same name already exists.',
  'A setting with the same name already exists, click Save to replace this setting.':
    'A setting with the same name already exists, click Save to replace this setting.',
  ACV: 'ACV',
  'AI Analysis Hub': 'AI Analysis Hub',
  'AI Analysis of Hot UGC Content': 'AI Analysis of Hot UGC Content',
  'AI Chat': 'AI Chat',
  'AI Chat History': 'AI Chat History',
  'AI Content Summary': 'AI Content Summary',
  'AI Core Content': 'AI Core Content',
  'AI Hook Analysis': 'AI Hook Analysis',
  'AI Insight Report': 'AI Insight Report',
  'AI Live Stream Comments Summary': 'AI Live Stream Comments Summary',
  'AI Meme Interpretation': 'AI Meme Interpretation',
  'AI Opinions Summary': 'AI Opinions Summary',
  'AI Options': 'AI Options',
  'AI Quantitative Summary': 'AI Quantitative Summary',
  'AI Settings': 'AI Settings',
  'AI Summary': 'AI Summary',
  'AI Summary Demo': 'AI Summary Demo',
  'AI Summary Events': 'AI Summary Events',
  'AI Summary Setting': 'AI Summary Setting',
  'AI Tagging': 'AI Tagging',
  'AI Tags': 'AI Tags',
  'AI Task Center': 'AI Task Center',
  'AI Topic': 'AI Topic',
  'AI Topic Analysis': 'AI Topic Analysis',
  'AI summary is not currently supported for this content type.':
    'AI summary is not currently supported for this content type.',
  'AI-generated': 'AI-generated',
  'AI Topic Subscriptions': 'AI Topic Subscriptions',
  'ALL Reviews Positive%': 'ALL Reviews Positive%',
  'AVG DAU': 'AVG DAU',
  'AVG Negative': 'AVG Negative',
  'AVG Positive': 'AVG Positive',
  Access: 'Access',
  Account: 'Account',
  'Account Monitor': 'Account Monitor',
  'Account Post': 'Account Post',
  'Account Posts': 'Account Posts',
  'Account Posts & Engagement': 'Account Posts & Engagement',
  'Account Posts: Summary of the number of Account posts on social media.':
    'Account Posts: Summary of the number of Account posts on social media.',
  'Account Trends': 'Account Trends',
  Accumulated: 'Accumulated',
  'Accumulated Daily New Ads': 'Accumulated Daily New Ads',
  'Accumulated Monthly Cumulative Impressions': 'Cumulative Impressions',
  'Accumulated Monthly New Ads': 'Accumulated New Ads',
  'Accumulated Monthly New Creatives': 'Accumulated New Creatives',
  'Accumulated New Ads': 'Accumulated New Ads',
  'Accumulated New Creatives': 'Accumulated New Creatives',
  'Accumulated Weekly Cumulative Impressions': 'Cumulative Impressions',
  'Accumulated Weekly New Ads': 'Accumulated New Ads',
  'Accumulated Weekly New Creatives': 'Accumulated New Creatives',
  Action: 'Action',
  Actions: 'Actions',
  Active: 'Active',
  'Active Ad Channel Analysis': 'Active Ad Channel Analysis',
  'Active Ads': 'Active Ads',
  'Active Ads Channel Share': 'Active Ads Channel Share',
  'Active Ads Competitor Share': 'Active Ads Competitor Share',
  'Active Ads Country & Type Analysis': 'Active Ads Country & Type Analysis',
  'Active Ads Engagements': 'Active Ads Engagements',
  'Active Ads Estimated Heat': 'Active Ads Estimated Heat',
  'Active Ads Impressions': 'Active Ads Impressions',
  'Active Ads by Country': 'Active Ads by Country',
  'Active Ads by Creative Type': 'Active Ads by Creative Type',
  'Active Ads% by Channel': 'Active Ads% by Channel',
  'Active Creatives': 'Active Creatives',
  'Active Date': 'Active Date',
  'Active Days': 'Active Days',
  'Active Image Ads': 'Active Image Ads',
  'Active Playable Ads': 'Active Playable Ads',
  'Active Video Ads': 'Active Video Ads',
  'Ad Count': 'Ad Count',
  'Ad Creatives': 'Ad Creatives',
  'Ad Cumulative Heat': 'Ad Cumulative Heat',
  'Ad Delivery Overview': 'Ad Delivery Overview',
  'Ad Duration': 'Ad Duration',
  Add: 'Add',
  'Add & Sort Games': 'Add & Sort Games',
  'Add Filter': 'Add Filter',
  'Add Filters': 'Add Filters',
  'Add Games to Compare': 'Add Games to Compare',
  'Add Schedule': 'Add Schedule',
  'Add Security-Related Crawling Keywords': 'Add Security-Related Crawling Keywords',
  'Add URL': 'Add URL',
  'Add a new version': 'Add a new version',
  'Add modules': 'Add modules',
  'Add publish schedule for {day}': 'Add publish schedule for {day}',
  'Add through the directory': 'Add through the directory',
  'Add to My Report': 'Add to My Report',
  'Add to My Reports': 'Add to My Reports',
  'Added AI Tag, Click to View': 'Added AI Tag, Click to View',
  'Added AI Video Content Summary, Click to View': 'Added AI Video Content Summary, Click to View',
  'Added Comment Count': 'Added Comment Count',
  'Added Negative%': 'Added Negative%',
  'Added Rating': 'Added Rating',
  'Added Reviews': 'Added Reviews',
  'Added Reviews Positive%': 'Added Reviews Positive%',
  'Adding all relevant words': 'Adding all relevant words',
  'Addition failed.': 'Addition failed.',
  Adj: 'Adj',
  Ads: 'Ads',
  'Ads-1': 'Ads',
  Advanced: 'Advanced',
  'Advanced Quantitative Summary': 'Advanced Quantitative Summary',
  'Advanced Summary': 'Advanced Summary',
  'Advanced quantitative — AI captures more opinions and quantifies each precisely.':
    'Advanced quantitative — AI captures more opinions and quantifies each precisely.',
  'After changing the filter criteria, you need to click confirm to refresh the page.':
    'After changing the filter criteria, you need to click confirm to refresh the page.',
  'After searching the name of the competitor, click the button of the Opinions system to enter the Opinions homepage of the competitor.':
    'After searching the name of the competitor, click the button of the Opinions system to enter the Opinions homepage of the competitor.',
  'After selecting keywords or topics, filtering for posts is currently not supported.':
    'After selecting keywords or topics, filtering for posts is currently not supported.',
  'After selecting the First Correlation Words on the left, the corresponding Second Correlation Words will be displayed here.':
    'After selecting the First Correlation Words on the left, the corresponding Second Correlation Words will be displayed here.',
  'After selecting the hour filter, the newly added hour section is set to move up by default.':
    'After selecting the hour filter, the newly added hour section is set to move up by default.',
  'After the AI summary is complete, it will be displayed automatically. No need to wait on this page.':
    'After the AI summary is complete, it will be displayed automatically. No need to wait on this page.',
  'After the data is loaded, the report image can be downloaded.':
    'After the data is loaded, the report image can be downloaded.',
  'After unsubscribing, you will no longer receive AI Summary WeCom notifications.':
    'After unsubscribing, you will no longer receive AI Summary WeCom notifications.',
  'After unsubscribing, you will no longer receive AI Summary email notifications.':
    'After unsubscribing, you will no longer receive AI Summary email notifications.',
  Agent: 'Agent',
  Aggregated: 'Aggregated',
  Airtime: 'Airtime',
  'Airtime (hours)': 'Airtime (hours)',
  'Airtime(hours)': 'Airtime(hours)',
  'Airtime: take the sum value of the hours broadcast by all streamers.':
    'Airtime: take the sum value of the hours broadcast by all streamers.',
  'Alert Countries': 'Alert Countries',
  'Align to Release': 'Align to Release',
  'Aligned by Launch time': 'Aligned by Launch time',
  All: 'All',
  'All AI summary tasks generated on individual game pages will be displayed here':
    'All AI summary tasks generated on individual game pages will be displayed here',
  'All Articles': 'All Articles',
  'All Comments': 'All Comments',
  'All Editions': 'All Editions',
  'All Engagement': 'All Engagement',
  'All Engagements: the number of Engagements of videos and posts, including likes, comments, and shares.':
    'All Engagements: the number of Engagements of videos and posts, including likes, comments, and shares.',
  'All Followers': 'All Followers',
  'All Games': 'All Games',
  'All Likes': 'All Likes',
  'All Publications': 'All Publications',
  'All Reports': 'All Reports',
  'All Reviews': 'All Reviews',
  'All Reviews Negative%': 'All Reviews Negative%',
  'All Reviews Positive%': 'All Reviews Positive%',
  'All Reviews Positive%-1': 'All Reviews Positive%',
  'All Reviews of All Language': 'All Reviews of All Language',
  'All Reviews of Language': 'All Reviews of Language',
  'All Reviews of Supported Language': 'All Reviews of Supported Language',
  'All Reviews%': 'All Reviews%',
  'All Time': 'All Time',
  'All Topic': 'All Topic',
  'All Views': 'All Views',
  'All data below sourced from {Levelup} with 1 day delay (T-1)':
    'All data below sourced from {Levelup} with 1 day delay (T-1)',
  'All of Time': 'All of Time',
  'All reviews are displayed in their original text and can be translated into either Chinese or English.':
    'All reviews are displayed in their original text and can be translated into either Chinese or English.',
  'All-1': 'All',
  'An English GPT report will be generated for you from 时间 to 时间. Could you please confirm the email address to receive the report? You can click to view the preview format.':
    'An English GPT report will be generated for you from 时间 to 时间. Could you please confirm the email address to receive the report? You can click to view the preview format.',
  'Analysis Generate failed, please try again': 'Analysis Generate failed, please try again',
  'Analysis Name': 'Analysis Name',
  'Analysis Target': 'Analysis Target',
  'Analysis Task Progress': 'Analysis Task Progress',
  'Analysis Time Range': 'Analysis Time Range',
  'Analysis generate failed, please try again': 'Analysis generate failed, please try again',
  'Analysis save failed': 'Analysis save failed',
  'Analysis will cover comments from {date}. Please  verify whether this period includes the original post publication date.':
    'Analysis will cover comments from {date}. Please  verify whether this period includes the original post publication date.',
  'Analyze latest the 5-min clip': 'Analyze latest the 5-min clip',
  'Analyzes Opinions data using multivariate analysis, including mentions, sentiment, topics, channels, location, and language':
    'Analyzes Opinions data using multivariate analysis, including mentions, sentiment, topics, channels, location, and language',
  'Anchor Words': 'Anchor Words',
  'Anomaly Overview': 'Anomaly Overview',
  'App Annie DAU': 'App Annie DAU',
  'App Annie Download': 'App Annie Download',
  'App Annie MAU': 'App Annie MAU',
  'App Annie Revenue': 'App Annie Revenue',
  'App Annie WAU': 'App Annie WAU',
  'App Store': 'App Store',
  April: 'April',
  'Are you sure to remove from Favorites?': 'Are you sure to remove from Favorites?',
  'Are you sure to unsubscribed ？': 'Are you sure to unsubscribed ？',
  Article: 'Article',
  Asc: 'Asc',
  'At Review Time': 'At Review Time',
  'Attribute by': 'Attribute by',
  'Attribution Breakdown': 'Attribution Breakdown',
  'Audience Performance': 'Audience Performance',
  'Audience Reviews': 'Audience Reviews',
  August: 'August',
  'Auto Generated Sentiment': 'Auto Generated Sentiment',
  'Auto-saves to Summary List': 'Auto-saves to Summary List',
  'Automatically verify tagging accuracy': 'Automatically verify tagging accuracy',
  Availability: 'Availability',
  Average: 'Average',
  'Average Engagement': 'Average Engagement',
  'Average Rating': 'Average Rating',
  'Average the score values of all reviews for the selected filter (including Date, Region/Country, Sentiment, and other filters).':
    'Average the score values of all reviews for the selected filter (including Date, Region/Country, Sentiment, and other filters).',
  'Avg Brand Affinity': 'Avg Brand Affinity',
  'Avg CCV': 'Avg CCV',
  'Avg CCV (Average concurrent viewers): Average number of viewers per platform. The calculation method is as follows: After obtaining the average value of viewers on each platform, the data is summarized, and then the average viewers value is calculated based on the summarized results.':
    'Avg CCV (Average concurrent viewers): Average number of viewers per platform. The calculation method is as follows: After obtaining the average value of viewers on each platform, the data is summarized, and then the average viewers value is calculated based on the summarized results.',
  'Avg CCV (Average concurrent viewers): take the average value of viewers watching the stream live.':
    'Avg CCV (Average concurrent viewers): take the average value of viewers watching the stream live.',
  'Avg Engagement': 'Avg Engagement',
  'Avg Engagement Rate': 'Avg Engagement Rate',
  'Avg Views': 'Avg Views',
  'Avg. Active Ads': 'Avg. Active Ads',
  'Avg. Active Ads Channel Share': 'Avg. Daily Active Ads Channel Share',
  'Avg. Active Ads Competitor Share': 'Avg. Daily Active Ads Competitor Share',
  'Avg. Active Ads Estimated Heat': 'Avg. Daily Active Ads Estimated Heat',
  'Avg. Active Creatives': 'Avg. Active Creatives',
  'Avg. CCV': 'Avg. CCV',
  'Avg. DAU': 'Avg. DAU',
  'Avg. Daily Active Ads': 'Avg. Daily Active Ads',
  'Avg. Daily Active Creatives': 'Avg. Daily Active Creatives',
  'Avg. Daily Active Image Ads': 'Avg. Daily Active Image Ads',
  'Avg. Daily Active Playable Ads': 'Avg. Daily Active Playable Ads',
  'Avg. Daily Active Video Ads': 'Avg. Daily Active Video Ads',
  'Avg. Days Active': 'Avg. Days Active',
  'Avg. Downloads': 'Avg. Downloads',
  'Avg. MAU': 'Avg. MAU',
  'Avg. Monthly Active Ads': 'Avg. Daily Active Ads',
  'Avg. Monthly Active Ads Channel Share': 'Avg. Daily Active Ads Channel Share',
  'Avg. Monthly Active Ads Competitor Share': 'Avg. Daily Active Ads Competitor Share',
  'Avg. Monthly Active Ads Engagements': 'Avg. Daily Active Ads Engagements',
  'Avg. Monthly Active Ads Estimated Heat': 'Avg. Daily Active Ads Estimated Heat',
  'Avg. Monthly Active Ads by Country': 'Active Ads by Country',
  'Avg. Monthly Active Ads by Creative Type': 'Active Ads by Creative Type',
  'Avg. Monthly Active Ads% by Channel': 'Active Ads% by Channel',
  'Avg. Monthly Active Creatives': 'Avg. Daily Active Creatives',
  'Avg. Monthly Active Image Ads': 'Avg. Daily Active Image Ads',
  'Avg. Monthly Active Playable Ads': 'Avg. Daily Active Playable Ads',
  'Avg. Monthly Active Video Ads': 'Avg. Daily Active Video Ads',
  'Avg. Monthly Cumulative Impressions by Type': 'Cumulative Impressions by Type',
  'Avg. Monthly Estimated Cumulative Heat': 'Estimated Cumulative Heat',
  'Avg. Monthly Total Impressions on Active Ads': 'Avg. Daily Total Impressions',
  'Avg. Rating of Game Store Reviews': 'Avg. Rating of Game Store Reviews',
  'Avg. Sentiment': 'Avg. Sentiment',
  'Avg. Total Impressions on Active Ads': 'Avg. Daily Total Impressions',
  'Avg. Views / Video': 'Avg. Views / Video',
  'Avg. WAU': 'Avg. WAU',
  'Avg. Weekly Active Ads': 'Avg. Daily Active Ads',
  'Avg. Weekly Active Ads Channel Share': 'Avg. Daily Active Ads Channel Share',
  'Avg. Weekly Active Ads Competitor Share': 'Avg. Daily Active Ads Competitor Share',
  'Avg. Weekly Active Ads Engagements': 'Avg. Daily Active Ads Engagements',
  'Avg. Weekly Active Ads Estimated Heat': 'Avg. Daily Active Ads Estimated Heat',
  'Avg. Weekly Active Ads by Country': 'Active Ads by Country',
  'Avg. Weekly Active Ads by Creative Type': 'Active Ads by Creative Type',
  'Avg. Weekly Active Ads% by Channel': 'Active Ads% by Channel',
  'Avg. Weekly Active Creatives': 'Avg. Daily Active Creatives',
  'Avg. Weekly Active Image Ads': 'Avg. Daily Active Image Ads',
  'Avg. Weekly Active Playable Ads': 'Avg. Daily Active Playable Ads',
  'Avg. Weekly Active Video Ads': 'Avg. Daily Active Video Ads',
  'Avg. Weekly Cumulative Impressions by Type': 'Cumulative Impressions by Type',
  'Avg. Weekly Estimated Cumulative Heat': 'Estimated Cumulative Heat',
  'Avg. Weekly Total Impressions on Active Ads': 'Avg. Daily Total Impressions',
  BR: 'BR',
  Back: 'Back',
  'Bar chart': 'Bar chart',
  Basic: 'Basic',
  'Basic Summary': 'Basic Summary',
  Basics: 'Basics',
  Battleid: 'Battleid',
  Beat: 'Beat',
  'Because the {titile} is not available for this video.': 'Because the {titile} is not available for this video.',
  Before: 'Before',
  'Before {time}': 'Before {time}',
  Behind: 'Behind',
  Biweekly: 'Biweekly',
  'Block chart': 'Block chart',
  Body: 'Body',
  'Brand Affinity': 'Brand Affinity',
  'Brand Creator List': 'Brand Creator List',
  'Brand Health': 'Brand Health',
  'Brand Overview': 'Brand Overview',
  'Brand Performance': 'Brand Performance',
  'Brand-Related Avg Views': 'Brand-Related Avg Views',
  'Brand-Related Publications': 'Brand-Related Publications',
  'Brand-Related Views Loss Rate': 'Brand-Related Views Loss Rate',
  'Broad-match': 'Broad-match',
  'Broad-match with multiple languages': 'Broad-match with multiple languages',
  'Bubble Size = |{id}|': 'Bubble Size = |{id}|',
  'By Account': 'By Account',
  'By Channel': 'By Channel',
  'By Chapter': 'By Chapter',
  'By Content': 'By Content',
  'By Country': 'By Country',
  'By Date': 'By Date',
  'By Engagement': 'By Engagement',
  'By Engagement Type': 'By Engagement Type',
  'By Follower Range': 'By Follower Range',
  'By Followers': 'By Followers',
  'By Language': 'By Language',
  'By Media Type': 'By Media Type',
  'By Mentions Type': 'By Mentions Type',
  'By Official Account': 'By Official Account',
  'By Patch': 'By Patch',
  'By Rating': 'By Rating',
  'By Rating%': 'By Rating%',
  'By Region/Country': 'By Region/Country',
  'By Release-1': 'By Release',
  'By Season': 'By Season',
  'By Sentiment': 'By Sentiment',
  'By Subtopic': 'By Subtopic',
  'By Title': 'By Title',
  'By Validation': 'By Validation',
  'By Views': 'By Views',
  'By sorting, get information on the hottest and fastest growing internet influencers.':
    'By sorting, get information on the hottest and fastest growing internet influencers.',
  'CA7 Bug Report': 'CA7 Bug Report',
  'CA7 Feedback Report': 'CA7 Feedback Report',
  'CA7 Performance Report': 'CA7 Performance Report',
  CCV: 'CCV',
  'Calculated by Likes': 'Calculated by Likes',
  'Calculated by Views': 'Calculated by Views',
  'Calculated using TikTok data for new videos entering the all-time Top 500 by views.':
    'Calculated using TikTok data for new videos entering the all-time Top 500 by views.',
  'Calculation Method': 'Calculation Method',
  "Can't be empty": "Can't be empty",
  "Can't be null": "Can't be null",
  "Can't generate AI summary: No live stream comment found": "Can't generate AI summary: No live stream comment found",
  "Can't generate AI summary: No subtitle found": "Can't generate AI summary: No subtitle found",
  Cancel: 'Cancel',
  'Cannot be empty': 'Cannot be empty',
  Card: 'Card',
  Category: 'Category',
  'Category-2': 'Category',
  'Category-3': 'Category',
  Change: 'Change',
  'Change Breakdown by Dimension': 'Change Breakdown by Dimension',
  'Change Rate': 'Change Rate',
  'Change%': 'Change%',
  Channel: 'Channel',
  'Channel / Region / Market / Language Distribution (Top 3)':
    'Channel / Region / Market / Language Distribution (Top 3)',
  'Channel Comparison': 'Channel Comparison',
  'Channel Count': 'Channel Count',
  'Channel Covered': 'Channel Covered',
  'Channel Distribution': 'Channel Distribution',
  'Channel Performance': 'Channel Performance',
  'Channel Settings': 'Channel Settings',
  'Channel Share Rankings': 'Channel Share Rankings',
  'Channel Trends': 'Channel Trends',
  'Channel Type': 'Channel Type',
  'Channel-1': 'Channel',
  'Channel-2': 'Channel',
  'Channels Share': 'Channels Share',
  Chapter: 'Chapter',
  'Character Length': 'Character Length',
  Chatting: 'Chatting',
  Chinese: 'Chinese',
  'Chinese Translation': 'Chinese Translation',
  'Chinese Translation Editing': 'Chinese Translation Editing',
  'Chinese Translation': 'Chinese Translation',
  'Chinese Translation Editing': 'Chinese Translation Editing',
  'Chinese Translation Editing History': 'Chinese Translation Editing History',
  'Choose Region/Country': 'Choose Region/Country',
  'Choose Time': 'Choose Time',
  Citation: 'Citation',
  'Clear All': 'Clear All',
  'Clear game and date': 'Clear game and date',
  'Click a keyword to view the relevant reviews.': 'Click a keyword to view the relevant reviews.',
  'Click hashtag to view more details': 'Click hashtag to view more details',
  'Click on a keyword to access the details page for specific reviews.':
    'Click on a keyword to access the details page for specific reviews.',
  'Click on a keyword to view the relevant reviews.': 'Click on a keyword to view the relevant reviews.',
  'Click on any keyword to filter reviews.': 'Click on any keyword to filter reviews.',
  'Click the Setting button on the right to add competitors.':
    'Click the Setting button on the right to add competitors.',
  'Click the button below to create a new report, and it will automatically update based on your selected schedule.':
    'Click the button below to create a new report, and it will automatically update based on your selected schedule.',
  'Click the chart to filter the feeds data below': 'Click the chart to filter the feeds data below',
  'Click the chart to to view related keywords and reviews': 'Click the chart to to view related keywords and reviews',
  'Click the chart to view related reviews': 'Click the chart to view related reviews',
  'Click the chart to view related videos': 'Click the chart to view related videos',
  'Click the chart to view reviews. Sorted by [{sortBy}] by default.':
    'Click the chart to view reviews. Sorted by [{sortBy}] by default.',
  'Click the chart to view top 3 reviews': 'Click the chart to view top 3 reviews',
  'Click the row or the meme title to view detail': 'Click the row or the meme title to view detail',
  'Click the table to view the details of comments.': 'Click the table to view the details of comments.',
  'Click these metrics to view multi-dimensional live streaming data.':
    'Click these metrics to view multi-dimensional live streaming data.',
  'Click to apply': 'Click to apply',
  'Click to deselect negative reviews': 'Click to deselect negative reviews',
  'Click to deselect neutral reviews': 'Click to deselect neutral reviews',
  'Click to deselect positive reviews': 'Click to deselect positive reviews',
  'Click to deselect {sentiment} content': 'Click to deselect {sentiment} content',
  'Click to download all opinion metrics. You can check any metrics and split the metrics by the selected dimension.':
    'Click to download all opinion metrics. You can check any metrics and split the metrics by the selected dimension.',
  'Click to go to Feeds': 'Click to go to Feeds',
  'Click to go to Key Opinions': 'Click to go to Key Opinions',
  'Click to go to [Feeds]': 'Click to go to [Feeds]',
  'Click to go to [Key Opinions]': 'Click to go to [Key Opinions]',
  'Click to select negative reviews': 'Click to select negative reviews',
  'Click to select neutral reviews': 'Click to select neutral reviews',
  'Click to select positive reviews': 'Click to select positive reviews',
  'Click to select {sentiment} content': 'Click to select {sentiment} content',
  'Click to view channel & language distribution': 'Click to view channel & language distribution',
  'Click to view details': 'Click to view details',
  'Click to view recent event.': 'Click to view recent event.',
  'Click to view recent report': 'Click to view recent report',
  'Click to view recent score.': 'Click to view recent score.',
  'Click to view related {series}': 'Click to view related {series}',
  'Click to view the anomaly analysis': 'Click to view the anomaly analysis',
  "Click to {text} for the feedback's original data source": "Click to {text} for the feedback's original data source",
  Close: 'Close',
  'Close-1': 'Close',
  Cloud: 'Cloud',
  Coins: 'Coins',
  Collapse: 'Collapse',
  'Collapse All': 'Collapse All',
  'Collapse Filter': 'Collapse Filter',
  'Collected Countries': 'Collected Countries',
  'Collected via DataBrain crawler': 'Collected via DataBrain crawler',
  'Collected via DataBrain crawler, with statistics generated based on filters':
    'Collected via DataBrain crawler, with statistics generated based on filters',
  'Color = Report Type': 'Color = Report Type',
  Comment: 'Comment',
  'Comment Area': 'Comment Area',
  'Comment Channel Type': 'Comment Channel Type',
  'Comment Details': 'Comment Details',
  'Comment End Date': 'Comment End Date',
  'Comment Id': 'Comment Id',
  'Comment Sentiment': 'Comment Sentiment',
  'Comment Start Date': 'Comment Start Date',
  'Comment Summary': 'Comment Summary',
  'Comment Type': 'Comment Type',
  'Comment Uin': 'Comment Uin',
  'Comment language': 'Comment language',
  Comments: 'Comments',
  'Comments (Exclude Discord)': 'Comments (Exclude Discord)',
  'Comments Change%': 'Comments Change%',
  'Comments Engagement': 'Comments Engagement',
  'Comments On Posts': 'Comments On Posts',
  'Comments On Videos': 'Comments On Videos',
  'Comments Prompt Modification': 'Comments Prompt Modification',
  'Comments Summary': 'Comments Summary',
  'Comments on Posts': 'Comments on Posts',
  'Comments on Streams': 'Comments on Streams',
  'Comments on Text Posts': 'Comments on Text Posts',
  'Comments on Videos': 'Comments on Videos',
  'Comments on Videos-1': 'Comments on Videos',
  'Comments on this post have not yet been crawled.': 'Comments on this post have not yet been crawled.',
  'Comments-1': 'Comments',
  'Comments-2': 'Comments',
  Common: 'Common',
  'Common Publisher (0-1K)': 'Common Publisher (0-1K)',
  'Common(0K ~ 1K)': 'Common(0K ~ 1K)',
  Community: 'Community',
  'Community Analysis': 'Community Analysis',
  'Community Performance': 'Community Performance',
  'Community Performance Monitoring: Video, Streaming, and Influencers':
    'Community Performance Monitoring: Video, Streaming, and Influencers',
  Compare: 'Compare',
  'Compare Competitors': 'Compare Competitors',
  'Compare Key Metrics': 'Compare Key Metrics',
  'Compare by': 'Compare by',
  'Compare-1': 'Compare',
  'Compared with Average': 'Compared with Average',
  'Compared with the following period, there is no topic of mentions growth.':
    'Compared with the following period, there is no topic of mentions growth.',
  'Compares data indicators and opinion trends of your game with competitors':
    'Compares data indicators and opinion trends of your game with competitors',
  'Comparison Analysis': 'Comparison Analysis',
  'Comparison Overview': 'Comparison Overview',
  'Comparison of Active Ads by Country': 'Comparison of Active Ads by Country',
  Competitor: 'Competitor',
  'Competitor Information and Comparison': 'Competitor Information and Comparison',
  'Competitor KOL-AB': 'Competitor KOL-AB',
  'Competitor KOL-CODM': 'Competitor KOL-CODM',
  'Competitor KOL-FF': 'Competitor KOL-FF',
  'Competitor KOL-MLBB': 'Competitor KOL-MLBB',
  'Competitor KOL-Roblox': 'Competitor KOL-Roblox',
  Competitors: 'Competitors',
  'Competitors Ad Creatives': 'Competitors Ad Creatives',
  'Competitors-1': 'Competitors',
  'Completed (Crawled {count} comment)': 'Completed (Crawled {count} comment)',
  'Completed (Crawled {count} comments)': 'Completed (Crawled {count} comments)',
  Configuration: 'Configuration',
  'Configuration-1': 'Configuration',
  Configured: 'Configured',
  Confirm: 'Confirm',
  'Confirm Delete？': 'Confirm Delete？',
  Console: 'Console',
  'Contact {email} for assistance': 'Contact {email} for assistance',
  Contain: 'Contain',
  'Content Chinese': 'Content Chinese',
  'Content English': 'Content English',
  'Content Original': 'Content Original',
  'Content must contain exactly "{text}", including spaces and punctuation.':
    'Content must contain exactly "{text}", including spaces and punctuation.',
  'Content must mention both “{text}” and “{text1}”': 'Content must mention both “{text}” and “{text1}”',
  'Content must mention either “{text}” or exactly “{text1}”':
    'Content must mention either “{text}” or exactly “{text1}”',
  'Content must mention exactly “{text}”': 'Content must mention exactly “{text}”',
  'Content must mention “{text}” or “{text1}”': 'Content must mention “{text}” or “{text1}”',
  'Content scraped successfully, but no valid summary could be generated':
    'Content scraped successfully, but no valid summary could be generated',
  'Contextual Nearby Reviews': 'Contextual Nearby Reviews',
  'Contribution to Change (%)': 'Contribution to Change (%)',
  'Contribution(↓)': 'Contribution(↓)',
  'Copied failed': 'Copied failed',
  'Copied successfully': 'Copied successfully',
  Copy: 'Copy',
  'Copy review': 'Copy review',
  'Copy text': 'Copy text',
  Core: 'Core',
  'Core Function': 'Core Function',
  'Core Overview': 'Overview',
  'Core: Brand-Related': 'Core: Brand-Related',
  Correlation: 'Correlation',
  Count: 'Count',
  Country: 'Country',
  'Country Distribution': 'Country Distribution',
  'Country Settings': 'Country Settings',
  'Country data is only included if the hashtag is in its Top 100 within the selected time':
    'Country data is only included if the hashtag is in its Top 100 within the selected time',
  'Crawling failed': 'Crawling failed',
  'Create Analysis': 'Create Analysis',
  'Create Time': 'Create Time',
  'Create failed': 'Create failed',
  'Create success': 'Create success',
  'Create time': 'Create time',
  'Create time: {time}': 'Create time: {time}',
  'Creation Failed, please try again later': 'Creation Failed, please try again later',
  'Creative Metrics': 'Creative Metrics',
  'Creative Trends': 'Creative Trends',
  Creatives: 'Creatives',
  Creator: 'Creator',
  'Creator Hub Incentive': 'Creator Hub Incentive',
  Creators: 'Creators',
  'Critic Reviews': 'Critic Reviews',
  'Critic Score': 'Critic Score',
  'Critics Recommend%': 'Critics Recommend%',
  'Cross-Analysis': 'Cross-Analysis',
  'Cumulative Impressions': 'Cumulative Impressions',
  'Cumulative Impressions by Type': 'Cumulative Impressions by Type',
  'Cumulative Trend': 'Cumulative Trend',
  'Current Period Mentions': 'Current Period Mentions',
  'Current Period Mentions-1': 'Current Period Mentions',
  'Current Report': 'Current Report',
  'Current period': 'Current period',
  'Current selected': 'Current selected',
  'Current step failed. For any questions, please contact {email}.':
    'Current step failed. For any questions, please contact {email}.',
  'Currently, only global data comparisons are supported, if you need Google Trends Data for other countries/regions, please contact {contact}.':
    'Currently, only global data comparisons are supported, if you need Google Trends Data for other countries/regions, please contact {contact}.',
  Custom: 'Custom',
  'Custom AI Summary': 'Custom AI Summary',
  'Custom Analysis Time Range': 'Custom Analysis Time Range',
  'Custom Input': 'Custom Input',
  'Custom date range is not supported at this time for AI summaries.':
    'Custom date range is not supported at this time for AI summaries.',
  'Customer Reviews': 'Customer Reviews',
  'Customer/User/Audience Reviews': 'Customer/User/Audience Reviews',
  Customize: 'Customize',
  Customized: 'Customized',
  'Customized Topic': 'Customized Topic',
  'Custom AI Summary': 'Custom AI Summary',
  DAU: 'DAU',
  Daily: 'Daily',
  'Daily Added Reviews': 'Daily Added Reviews',
  'Daily Dashboard': 'Daily Dashboard',
  'Daily Discuss Players': 'Daily Discuss Players',
  'Daily Engagement': 'Daily Engagement',
  'Daily Mentions': 'Daily Mentions',
  'Daily Number of Creators': 'Daily Number of Creators',
  'Daily Publications': 'Daily Publications',
  'Daily Report': 'Daily Report',
  'Daily Sentiment': 'Daily Sentiment',
  'Daily Trend': 'Daily Trend',
  'Daily Views': 'Daily Views',
  Danmu: 'Danmu',
  Dashboard: 'Dashboard',
  'Data Granularity': 'Data Granularity',
  'Data Map': 'Data Map',
  'Data Selection:': 'Data Selection:',
  'Data Source': 'Data Source',
  'Data Source and Metrics': 'Data Source and Metrics',
  'Data Source:': 'Data Source:',
  'Data Update': 'Data Update',
  'Data Update & Tags': 'Data Update & Tags',
  'Data Update: Not real-time data': 'Data Update: Not real-time data',
  'Data available after launch': 'Data available after launch',
  'Data available on the 31st day after launch': 'Data available on the 31st day after launch',
  'Data from:': 'Data from:',
  'Data statistics are directly sourced from the Steam page':
    'Data statistics are directly sourced from the Steam page',
  Date: 'Date',
  'Date Duration': 'Date Duration',
  'Date Range': 'Date Range',
  'Date-1': 'Date',
  Day: 'Day',
  'Day-1': 'Day',
  Days: 'Days',
  'Days Active': 'Days Active',
  December: 'December',
  'DeepSeek will take 1 to 3 minutes, depending on the content.':
    'DeepSeek will take 1 to 3 minutes, depending on the content.',
  Default: 'Default',
  'Default Date: Today': 'Default Date: Today',
  'Default Sorting': 'Default Sorting',
  'Default prompt': 'Default prompt',
  Definition: 'Definition',
  'Definition Optimization:': 'Definition Optimization:',
  Delete: 'Delete',
  'Delete Analysis?': 'Delete Analysis?',
  'Delete Repeat Task?': 'Delete Repeat Task?',
  'Delete URL': 'Delete URL',
  'Delete failed': 'Delete failed',
  'Delete success': 'Delete success',
  'Delete the filter setting': 'Delete the filter setting',
  'Delete {name}? Deletion is irreversible, please proceed with caution.':
    'Delete {name}? Deletion is irreversible, please proceed with caution.',
  'Delete {name}{type}? Deletion is irreversible, please proceed with caution.':
    'Delete {name}{type}? Deletion is irreversible, please proceed with caution.',
  'Demo:': 'Demo:',
  Des: 'Des',
  Description: 'Description',
  Detail: 'Detail',
  'Detailed feeds': 'Detailed feeds',
  Details: 'Details',
  'Details Page': 'Details Page',
  'Details of Overseas All-Channel Opinions Feeds': 'Details of Overseas All-Channel Opinions Feeds',
  'Different Start Date (For Event Analysis)': 'Different Start Date (For Event Analysis)',
  'Digital Revenue': 'Digital Revenue',
  'Digital Revenue ($)': 'Digital Revenue ($)',
  'Digital Units': 'Digital Units',
  Dimension: 'Dimension',
  'Discord Chats': 'Discord Chats',
  Discussions: 'Discussions',
  Dislike: 'Dislike',
  'Display 20 reviews from the same Official Account (if any)':
    'Display 20 reviews from the same Official Account (if any)',
  'Display 20 reviews from the same official Account (if any)':
    'Display 20 reviews from the same official Account (if any)',
  'Display all reviewers including those in the list below': 'Display all reviewers including those in the list below',
  'Display top 10 topics by default': 'Display top 10 topics by default',
  Distance: 'Distance',
  Distribution: 'Distribution',
  'Diverging Chart': 'Diverging Chart',
  'Do you want to delete this article?': 'Do you want to delete this article?',
  'Do you want to delete?': 'Do you want to delete?',
  DoD: 'DoD',
  "Don't save the edited content?": "Don't save the edited content?",
  Done: 'Done',
  'Dot = Subtopic': 'Dot = Subtopic',
  'Dot = Subtopic | X-axis = Weekly Mentions | Y-axis = Average Engagement (Mentions / Engagements) | Color = Report Type | Bubble Size = |WoW%| ↑ Increase ↓ Decrease':
    'Dot = Subtopic | X-axis = Weekly Mentions | Y-axis = Average Engagement (Mentions / Engagements) | Color = Report Type | Bubble Size = |WoW%| ↑ Increase ↓ Decrease',
  Download: 'Download',
  'Download Image': 'Download Image',
  'Download Original Comments': 'Download Original Comments',
  'Download PDF Document': 'Download PDF Document',
  'Download Settings': 'Download Settings',
  'Download failed due to excessive data. We recommend exporting in batches or applying additional filters.':
    'Download failed due to excessive data. We recommend exporting in batches or applying additional filters.',
  'Download failed, please refresh the page': 'Download failed, please refresh the page',
  'Download this report': 'Download this report',
  Downloads: 'Downloads',
  'Downloads exceed the {num} limit. Please adjust filters and retry.':
    'Downloads exceed the {num} limit. Please adjust filters and retry.',
  'Download failed, please refresh the page.': 'Download failed, please refresh the page.',
  'Drill-down analysis is only supported for featured streamers and popular live streaming rooms.':
    'Drill-down analysis is only supported for featured streamers and popular live streaming rooms.',
  'Dual-Axis Comparison with Active Ads': 'Dual-Axis Comparison with Active Ads',
  'Due to insufficient selected content, GPT is currently unable to summarize the report as requested.':
    'Due to insufficient selected content, GPT is currently unable to summarize the report as requested.',
  'Due to the instability of the DeepSeek API, Deepseek is currently unable to summarize the report as requested.':
    'Due to the instability of the DeepSeek API, Deepseek is currently unable to summarize the report as requested.',
  'Due to the instability of the GPT API, GPT is currently unable to summarize the report as requested.':
    'Due to the instability of the GPT API, GPT is currently unable to summarize the report as requested.',
  'Due to the instability of the Gemini API, Gemini is currently unable to summarize the report as requested.':
    'Due to the instability of the Gemini API, Gemini is currently unable to summarize the report as requested.',
  'Due to the small number of selected reviews, DeepSeek is currently unable to summarize the report as requested.':
    'Due to the small number of selected reviews, DeepSeek is currently unable to summarize the report as requested.',
  'Due to the small number of selected reviews, GPT is currently unable to summarize the report as requested.':
    'Due to the small number of selected reviews, GPT is currently unable to summarize the report as requested.',
  'Due to the small number of selected reviews, Gemini is currently unable to summarize the report as requested.':
    'Due to the small number of selected reviews, Gemini is currently unable to summarize the report as requested.',
  Duration: 'Duration',
  'Duration-1': 'Duration',
  EMPTY: ' ',
  'Early Access Reviews': 'Early Access Reviews',
  Earned: 'Earned',
  'Earned Content': 'Earned Content',
  'Earned Content - Organic': 'Earned Content - Organic',
  'Earned Content - Partnered': 'Earned Content - Partnered',
  Edit: 'Edit',
  'Edit Fail': 'Edit Fail',
  'Edit Module': 'Edit Module',
  'Edit My Following Games': 'Edit My Following Games',
  'Edit Name': 'Edit Name',
  'Edit Prompt': 'Edit Prompt',
  'Edit Repeat Settings': 'Edit Repeat Settings',
  'Edit Report': 'Edit Report',
  'Edit Success': 'Edit Success',
  'Edit failed': 'Edit failed',
  'Edit publish schedule for {day}': 'Edit publish schedule for {day}',
  'Edit translation': 'Edit translation',
  'Edit version': 'Edit version',
  'Editing History': 'Editing History',
  'Editing History': 'Editing History',
  'Effective Date': 'Effective Date',
  Email: 'Email',
  'Email Address': 'Email Address',
  'Email Title': 'Email Title',
  'Email title must be filled in.': 'Email title must be filled in.',
  Emerging: 'Emerging',
  'Emerging Keywords': 'Emerging Keywords',
  "Emerging Keywords: Keywords that appear in the last hour, but haven't appeared in the last 3 or 5 days (Days of Game Store/ Monitoring Keywords/ Monitor Accounts are different), as Emerging keywords.":
    "Emerging Keywords: Keywords that appear in the last hour, but haven't appeared in the last 3 or 5 days (Days of Game Store/ Monitoring Keywords/ Monitor Accounts are different), as Emerging keywords.",
  "Emerging Topic&Keywords：Based on the algorithm, Databrain identifies and tags the game's Emerging Keywords. Here are the top 30 Emerging Keywords in terms of Mentions, and topics aggregated based on these keywords.":
    "Emerging Topic&Keywords：Based on the algorithm, Databrain identifies and tags the game's Emerging Keywords. Here are the top 30 Emerging Keywords in terms of Mentions, and topics aggregated based on these keywords.",
  'Emotion Amplification': 'Emotion Amplification',
  'Emotion Amplifying – High Attention Required': 'Emotion Amplifying – High Attention Required',
  'Encountered an issue with the download. Please try again later or contact {contact} for assistance.':
    'Encountered an issue with the download. Please try again later or contact {contact} for assistance.',
  'End Time': 'End Time',
  Engagement: 'Engagement',
  'Engagement Change%': 'Engagement Change%',
  'Engagement Rate': 'Engagement Rate',
  'Engagement by sentiment': 'Engagement by sentiment',
  'Engagement%': 'Engagement%',
  'Engagement%-1': 'Engagement%',
  'Engagement%: Change%': 'Engagement%: Change%',
  'Engagement-2': 'Engagement',
  'Engagement-3': 'Engagement',
  'Engagement: Change%': 'Engagement: Change%',
  'Engagement: Summary of Likes, Comments and Shares of all Reviews (Posts & Comments).':
    'Engagement: Summary of Likes, Comments and Shares of all Reviews (Posts & Comments).',
  Engagements: 'Engagements',
  'Engagements (Likes + Shares + Comments)': 'Engagements (Likes + Shares + Comments)',
  English: 'English',
  'English Translation': 'English Translation',
  'English Translation Editing': 'English Translation Editing',
  'English Translation': 'English Translation',
  'English Translation Editing': 'English Translation Editing',
  'English Translation Editing History': 'English Translation Editing History',
  Enlarge: 'Enlarge',
  'Enter an English name or email address to search, then select and add from the drop-down list.':
    'Enter an English name or email address to search, then select and add from the drop-down list.',
  'Enter an integer greater than {min}.': 'Enter an integer greater than {min}.',
  'Enter custom keywords for exact-match or expand-match, supporting AND/OR relationships for precise filtering.':
    'Enter custom keywords for exact-match or expand-match, supporting AND/OR relationships for precise filtering.',
  Escalated: 'Escalated',
  'Escalated – Immediate Action Required': 'Escalated – Immediate Action Required',
  'Escalating Subtopics': 'Escalating Subtopics',
  'Estimated Cumulative Heat': 'Estimated Cumulative Heat',
  Event: 'Event',
  'Event Details': 'Event Details',
  'Event List': 'Event List',
  'Event Summary': 'Event Summary',
  'Event Tracking': 'Event Tracking',
  'Event type': 'Event type',
  Events: 'Events',
  'Events Setting': 'Events Setting',
  'Events-1': 'Events',
  Everyone: 'Everyone',
  'Exact Search': 'Exact Search',
  'Exact Search: When we enter a keyword, the system will precisely match it in the original text, English translation, and Chinese translation of the reviews, excluding unrelated terms. For instance, if we enter "good," the system will only display reviews containing the exact word "good" in any of these versions, without including related terms like "better."':
    'Exact Search: When we enter a keyword, the system will precisely match it in the original text, English translation, and Chinese translation of the reviews, excluding unrelated terms. For instance, if we enter "good," the system will only display reviews containing the exact word "good" in any of these versions, without including related terms like "better."',
  'Exact-match': 'Exact-match',
  'Example：Bug; Issue': 'Example：Bug; Issue',
  'Exceeds the maximum span of the currently selected version.':
    'Exceeds the maximum span of the currently selected version.',
  'Except for Steam, the remaining data is still being crawled, and the change rate is unreliable.':
    'Except for Steam, the remaining data is still being crawled, and the change rate is unreliable.',
  'Exchange position': 'Exchange position',
  Exclude: 'Exclude',
  'Exclude Invalid': 'Exclude Invalid',
  'Exclude Invalid Reviews': 'Exclude Invalid Reviews',
  'Exclude Low & Invalid': 'Exclude Low & Invalid',
  'Exclude Neutral': 'Exclude Neutral',
  'Exclude Only Contain': 'Exclude Only Contain',
  'Exclude unlabeled reviews': 'Exclude unlabeled reviews',
  Excluding: 'Excluding',
  'Execution Progress': 'Execution Progress',
  'Executive Summary': 'Executive Summary',
  'Expand All': 'Expand All',
  'Expand all Tier 1 topic': 'Expand all Tier 1 topic',
  'Expected to wait for 0.5h~2h': 'Expected to wait for 0.5h~2h',
  'Expected to wait for 0.5h~2h,  depending on the content.':
    'Expected to wait for 0.5h~2h,  depending on the content.',
  'Extended Search': 'Extended Search',
  'External Sources': 'External Sources',
  Failed: 'Failed',
  'Failed to fetch authentication information. If you have any questions, please contact {email}':
    'Failed to fetch authentication information. If you have any questions, please contact {email}',
  'Failed to load video': 'Failed to load video',
  'Failed to obtain authentication token. If you have any questions, please contact {email}':
    'Failed to obtain authentication token. If you have any questions, please contact {email}',
  'Failed to retrieve game information. If you have any questions, please contact {email}':
    'Failed to retrieve game information. If you have any questions, please contact {email}',
  'Failed to retrieve report URL. If you have any questions, please contact {email}':
    'Failed to retrieve report URL. If you have any questions, please contact {email}',
  'Failed to retrieve report information. If you have any questions, please contact {email}':
    'Failed to retrieve report information. If you have any questions, please contact {email}',
  'Failed to retrieve the files required for AI Chat; please contact {name} ({email}).':
    'Failed to retrieve the files required for AI Chat; please contact {name} ({email}).',
  'Favorite Page': 'Favorite Page',
  Favorites: 'Favorites',
  Featured: 'Featured',
  February: 'February',
  Feeds: 'Feeds',
  'Feeds AI Summary': 'Feeds AI Summary',
  'Feeds GPT Summary': 'Feeds GPT Summary',
  'Feeds/Reviews Detailed': 'Feeds/Reviews Detailed',
  'Filter Setting': 'Filter Setting',
  'Filter Setting Name': 'Filter Setting Name',
  'Filter Settings': 'Filter Settings',
  'Filtered Avg. Rating': 'Filtered Avg. Rating',
  'Filtered Influencer': 'Filtered Influencer',
  'Filtered Positive%': 'Filtered Positive%',
  'Filtered Rating': 'Filtered Rating',
  'Filtered Reviews': 'Filtered Reviews',
  'Filtered Total': 'Filtered Total',
  'First Correlation Words': 'First Correlation Words',
  'First Report Time Range:': 'First Report Time Range:',
  'First Seen': 'First Seen',
  'First Seen-1': 'First Seen',
  Fold: 'Fold',
  'Fold all Tier 1 topic': 'Fold all Tier 1 topic',
  Follow: 'Follow',
  'Follower Range': 'Follower Range',
  'Follower/Subscriber': 'Follower/Subscriber',
  Followers: 'Followers',
  'Followers (Top 50 AVG)': 'Followers (Top 50 AVG)',
  'Followers Update: Only update the followers of opinion leaders with more than 5K followers or who post on that day.\nCalculation logic of daily views, likes and comments: Summarize posts on a daily basis, and count the data of these posts (such as views, likes and comments and engagement) as the views, likes, comments and engagement on the Posting day.\nInfluencers Data was updated from March 11, 2023.':
    'Followers Update: Only update the followers of opinion leaders with more than 5K followers or who post on that day.\nCalculation logic of daily views, likes and comments: Summarize posts on a daily basis, and count the data of these posts (such as views, likes and comments and engagement) as the views, likes, comments and engagement on the Posting day.\nInfluencers Data was updated from March 11, 2023.',
  "Followers difference of adjacent intervals: The difference is obtained by subtracting the followers data of the previous interval from the current interval. Negative numbers represent declines and positive numbers represent increases.\nFollowers' source of each platform: Reddit is taken from Members, Youtube is taken from Subscribe, and other platforms are taken from Followers.":
    "Followers difference of adjacent intervals: The difference is obtained by subtracting the followers data of the previous interval from the current interval. Negative numbers represent declines and positive numbers represent increases.\nFollowers' source of each platform: Reddit is taken from Members, Youtube is taken from Subscribe, and other platforms are taken from Followers.",
  'Followers source of each platform: Reddit is taken from Members, Youtube is taken from Subscribe, and other platforms are taken from Followers.':
    'Followers source of each platform: Reddit is taken from Members, Youtube is taken from Subscribe, and other platforms are taken from Followers.',
  'Followers(Top 10 AVG)': 'Followers(Top 10 AVG)',
  'Followers/Subscribers': 'Followers/Subscribers',
  Following: 'Following',
  'Free Played': 'Free Played',
  Frequency: 'Frequency',
  'Frequency-2': 'Frequency',
  Friday: 'Friday',
  'From GPT-Translator. Powered by DataBrain NLP Team': 'From GPT-Translator. Powered by DataBrain NLP Team',
  'From Google Translate': 'From Google Translate',
  "From the game's release on Steam to {time}, language statistics are directly derived from the Steam page":
    "From the game's release on Steam to {time}, language statistics are directly derived from the Steam page",
  "From the game's release to {date}": "From the game's release to {date}",
  'Funny(people)': 'Funny(people)',
  'Fuzzy-match': 'Fuzzy-match',
  'GPT Auto Report': 'GPT Auto Report',
  'GPT Options': 'GPT Options',
  'GPT Report is being generated.': 'GPT Report is being generated.',
  'GPT Reports': 'GPT Reports',
  'GPT Settings': 'GPT Settings',
  'GPT Summary': 'GPT Summary',
  'GPT Summary: By Language': 'GPT Summary: By Language',
  "GPT Summary: KOLs' Opinions": "GPT Summary: KOLs' Opinions",
  'GPT will take 1 to 3 minutes, depending on the content.': 'GPT will take 1 to 3 minutes, depending on the content.',
  Game: 'Game',
  'Game (Sort by DAU)': 'Game (Sort by DAU)',
  'Game Affinity': 'Game Affinity',
  'Game Analysis Name': 'Game Analysis Name',
  'Game Comparison Table': 'Game Comparison Table',
  'Game Duration(hours)': 'Game Duration(hours)',
  'Game List': 'Game List',
  'Game Performance Cross-Analysis': 'Game Performance Cross-Analysis',
  'Game Ranking List': 'Game Ranking List',
  'Game Selection': 'Game Selection',
  'Game Store': 'Game Store',
  'Game Store Reviews': 'Game Store Reviews',
  'Game Type': 'Game Type',
  'Game data is currently unavailable (due to unconfigured settings or lack of permissions). Please contact miamgao@tencent.com for assistance.':
    'Game data is currently unavailable (due to unconfigured settings or lack of permissions). Please contact miamgao@tencent.com for assistance.',
  'Game monitored': 'Game monitored',
  Games: 'Games',
  'Games Covered': 'Games Covered',
  'Games-1': 'Games',
  'Gemini will take 1 to 3 minutes, depending on the content.':
    'Gemini will take 1 to 3 minutes, depending on the content.',
  'General Game KOL': 'General Game KOL',
  'General Summary': 'General Summary',
  'Generate Analysis': 'Generate Analysis',
  'Generate Report': 'Generate Report',
  'Generate Summary': 'Generate Summary',
  'Generate a summary of the opinions obtained. Highlight several most positive and negative topics, providing comprehensive examples for each. Conclude the report with a succinct executive summary. Please be as detailed as possible, and give examples of the comments.':
    'Generate a summary of the opinions obtained. Highlight several most positive and negative topics, providing comprehensive examples for each. Conclude the report with a succinct executive summary. Please be as detailed as possible, and give examples of the comments.',
  'Generate a summary of the opinions obtained. Highlight the three most positive and negative topics, providing comprehensive examples for each. Conclude the report with a succinct executive summary.':
    'Generate a summary of the opinions obtained. Highlight the three most positive and negative topics, providing comprehensive examples for each. Conclude the report with a succinct executive summary.',
  'Generate and Repeat': 'Generate and Repeat',
  'Generate and Repeat Settings': 'Generate and Repeat Settings',
  Generating: 'Generating',
  'Generating a summary now using Deepseek': 'Generating a summary now using Deepseek',
  'Generating a summary now using GPT-4': 'Generating a summary now using GPT-4',
  'Generating a summary now using Gemini': 'Generating a summary now using Gemini',
  'Generating a summary now using {name}': 'Generating a summary now using {name}',
  'Generating summary by DeepSeek': 'Generating summary by DeepSeek',
  'Generating summary by GPT4.0': 'Generating summary by GPT4.0',
  'Generating summary by Gemini': 'Generating summary by Gemini',
  Genre: 'Genre',
  'Genre Creator List': 'Genre Creator List',
  'Genre: Genre-Related': 'Genre: Genre-Related',
  'Get AI Summary': 'Get AI Summary',
  'Get GPT Summary': 'Get GPT Summary',
  'Get the engagement metrics of the most popular videos and the number of followers the video creator has.':
    'Get the engagement metrics of the most popular videos and the number of followers the video creator has.',
  'Give UC': 'Give UC',
  Global: 'Global',
  'Global Hero Summary': 'Global Hero Summary',
  'Global data includes Influencer with no country/region defined.':
    'Global data includes Influencer with no country/region defined.',
  'Global except China mainland': 'Global except China mainland',
  'Global except China mainland refers to the reviews from game store and social media, that are collected from all regions/countries except China mainland, which cannot be distinguished from regions/countries.':
    'Global except China mainland refers to the reviews from game store and social media, that are collected from all regions/countries except China mainland, which cannot be distinguished from regions/countries.',
  'Global includes reviews from game store and social media, which cannot be distinguished from regions/market.':
    'Global includes reviews from game store and social media, which cannot be distinguished from regions/market.',
  'Global official channel monitoring for real-time performance of content and accounts':
    'Global official channel monitoring for real-time performance of content and accounts',
  'Global refers to the reviews from game store and social media, which cannot be distinguished from regions/countries.':
    'Global refers to the reviews from game store and social media, which cannot be distinguished from regions/countries.',
  'Go to': 'Go to',
  'Go to AI Analysis Hub': 'Go to AI Analysis Hub',
  'Go to AI Customized Summary': 'Go to AI Customized Summary',
  'Go to Feeds': 'Go to Feeds',
  'Go to Feeds page': 'Go to Feeds page',
  'Go to Key Opinions AI Analysis': 'Go to Key Opinions AI Analysis',
  'Go to Official Account': 'Go to Official Account',
  'Go to Reviews': 'Go to Reviews',
  'Go to Streaming page': 'Go to Streaming page',
  'Go to Video page': 'Go to Video page',
  "Go to influencer's homepage": "Go to influencer's homepage",
  'Go to original URL': 'Go to original URL',
  'Go to original post': 'Go to original post',
  'Go to the line graph': 'Go to the line graph',
  'Go to the original website (Steam).': 'Go to the original website (Steam).',
  "Go to the source website's personal homepage": "Go to the source website's personal homepage",
  'Google & Twitter Trends': 'Google & Twitter Trends',
  'Google & X Trends': 'Google & X Trends',
  'Google Play': 'Google Play',
  'Google Play reviews identify countries by language': 'Google Play reviews identify countries by language',
  'Google Trends': 'Google Trends',
  'Grammar error': 'Grammar error',
  'Grammar is correct': 'Grammar is correct',
  'Growth of Followers': 'Growth of Followers',
  Guidelines: 'Guidelines',
  Hashtag: 'Hashtag',
  'Hashtag AI Summary': 'Hashtag AI Summary',
  'Hashtag Details': 'Hashtag Details',
  'Hashtag Trend (By Last {num} days)': 'Hashtag Trend (By Last {num} days)',
  Hashtags: 'Hashtags',
  Healthy: 'Healthy',
  Heat: 'Heat',
  'Heat Trend': 'Heat Trend',
  'Helpful(people)': 'Helpful(people)',
  Hero: 'Hero',
  'Hide comparison chart of column data. Comparison chart calculation method: Based on the maximum value of the column where the value resides,  use a bar chart to show the proportion of the value to the maximum value.':
    'Hide comparison chart of column data. Comparison chart calculation method: Based on the maximum value of the column where the value resides,  use a bar chart to show the proportion of the value to the maximum value.',
  High: 'High',
  'High & Middle Validation': 'High & Middle Validation',
  'Highlight the scores of countries in which the declines exceed the threshold and need attention.':
    'Highlight the scores of countries in which the declines exceed the threshold and need attention.',
  'Historical prompt': 'Historical prompt',
  HoH: 'HoH',
  Hot: 'Hot',
  'Hot Content': 'Hot Content',
  'Hot Discussions': 'Hot Discussions',
  'Hot Event': 'Hot Event',
  'Hot Events': 'Hot Events',
  'Hot Events: Events ranked in the Top 3 for three or more consecutive days':
    'Hot Events: Events ranked in the Top 3 for three or more consecutive days',
  'Hot Hashtags': 'Hot Hashtags',
  'Hot UGC Videos': 'Hot UGC Videos',
  'Hot event is being generated.': 'Hot event is being generated.',
  'Hot-2': 'Hot',
  'Hottest Time': 'Hottest Time',
  Hour: 'Hour',
  Hourly: 'Hourly',
  'Hourly Added Mentions': 'Hourly Added Mentions',
  'Hourly Added Reviews': 'Hourly Added Reviews',
  'Hourly Avg. Mentions': 'Hourly Avg. Mentions',
  'Hourly Avg. Negative%': 'Hourly Avg. Negative%',
  'Hourly Dashboard': 'Hourly Dashboard',
  'Hourly Data Refresh': 'Hourly Data Refresh',
  'Hourly Discuss Players': 'Hourly Discuss Players',
  'Hourly Mentions': 'Hourly Mentions',
  'Hourly Negative%': 'Hourly Negative%',
  'Hourly Rising Keywords': 'Hourly Rising Keywords',
  'Hourly data unavailable in this section.': 'Hourly data unavailable in this section.',
  'Hours Watched': 'Hours Watched',
  'Hours Watched (hours)': 'Hours Watched (hours)',
  'Hours Watched(hours)': 'Hours Watched(hours)',
  ID: 'ID',
  'IEGG PR': 'IEGG PR',
  'IGN Video Report': 'IGN Video Report',
  'If necessary, please contact {contact}.': 'If necessary, please contact {contact}.',
  'If three consecutive data reports generated based on the update frequency are not accessed, the reports will automatically stop':
    'If three consecutive data reports generated based on the update frequency are not accessed, the reports will automatically stop',
  'If you have any question, feel free to contact {contact}.':
    'If you have any question, feel free to contact {contact}.',
  Image: 'Image',
  'Image Posts': 'Image Posts',
  'Image download': 'Image download',
  Images: 'Images',
  'Importance Editing History': 'Importance Editing History',
  Important: 'Important',
  'Important Score-1': 'Important Score',
  'Important Score-2': 'Important Score',
  Impressions: 'Impressions',
  'In Total': 'In Total',
  'In data scraping': 'In data scraping',
  'In order to improve the computational efficiency, we selected the mentions of the top 200 keywords and their related synonyms as total mentions. The reviews list displays reviews related to that keyword and all its synonyms, which may be slightly more numerous than the keyword cards.':
    'In order to improve the computational efficiency, we selected the mentions of the top 200 keywords and their related synonyms as total mentions. The reviews list displays reviews related to that keyword and all its synonyms, which may be slightly more numerous than the keyword cards.',
  'In queue': 'In queue',
  'In this section you can learn basic information about each data source in various dimensions.':
    'In this section you can learn basic information about each data source in various dimensions.',
  'In this section you can learn details about each metric in Opinions module.':
    'In this section you can learn details about each metric in Opinions module.',
  'In this section, all the news crawlers are listed out as below.':
    'In this section, all the news crawlers are listed out as below.',
  Include: 'Include',
  'Include Chitchat': 'Include Chitchat',
  'Including comments from game store and social media.': 'Including comments from game store and social media.',
  'Including the following Tier 2 Topics': 'Including the following Tier 2 Topics',
  'Including video influencer and post influencer.': 'Including video influencer and post influencer.',
  Index: 'Index',
  Influencer: 'Influencer',
  'Influencer Counts': 'Influencer Counts',
  'Influencer List': 'Influencer List',
  'Influencer Profile': 'Influencer Profile',
  Influencers: 'Influencers',
  'Influencers type: include video influencers and post influencers. The list presents the head influencer from largest to smallest by the sum of the number of Engagements posted with video and text within the user statistical period.\nData sources: include influencers with 5,000 or more followers, and those who have posted in the selected time range on each platform.':
    'Influencers type: include video influencers and post influencers. The list presents the head influencer from largest to smallest by the sum of the number of Engagements posted with video and text within the user statistical period.\nData sources: include influencers with 5,000 or more followers, and those who have posted in the selected time range on each platform.',
  'Influencers-1': 'Influencers',
  'Influencers-2': 'Influencers',
  'Information overload, please reduce reviews and try again':
    'Information overload, please reduce reviews and try again',
  'Input Number': 'Input Number',
  'Input relevant background knowledge or key focus areas here to generate a more tailored summary.':
    'Input relevant background knowledge or key focus areas here to generate a more tailored summary.',
  'Insight Analysis': 'Insight Analysis',
  Insights: 'Insights',
  'Insights Report': 'Insights Report',
  Intelligence: 'Intelligence',
  Intent: 'Intent',
  'Intent Distribution Trend': 'Intent Distribution Trend',
  Interval: 'Interval',
  'Introduces essential knowledge of Opinions, including data sources, terms, metrics, and calculations':
    'Introduces essential knowledge of Opinions, including data sources, terms, metrics, and calculations',
  Invalid: 'Invalid',
  'Invalid Filter': 'Invalid Filter',
  'Invalid Reviews': 'Invalid Reviews',
  'Invalid reviews are not supported for Chinese translation.':
    'Invalid reviews are not supported for Chinese translation.',
  'Items to be saved': 'Items to be saved',
  January: 'January',
  'Japan & Korea': 'Japan & Korea',
  July: 'July',
  June: 'June',
  'Just Updated': 'Just Updated',
  'KOL Quotes': 'KOL Quotes',
  'KOL Region/Country': 'KOL Region/Country',
  'KOLs Sort by {value}': 'KOLs Sort by {value}',
  'KPI Overview': 'Overview',
  'Key Country': 'Key Country',
  'Key Metrics': 'Key Metrics',
  'Key Metrics (Real-time)': 'Key Metrics (Real-time)',
  'Key Metrics Overview': 'Key Metrics Overview',
  'Key Metrics-1': 'Key Metrics',
  'Key Opinions': 'Key Opinions',
  'Key Opinions AI Analysis': 'Key Opinions AI Analysis',
  'Key Opinions GPT Analysis': 'Key Opinions GPT Analysis',
  'Key Topic': 'Key Topic',
  'Key Topics': 'Key Topics',
  Keyword: 'Keyword',
  'Keyword & Topic Analysis': 'Keyword & Topic Analysis',
  'Keyword & URL Analysis': 'Keyword & URL Analysis',
  'Keyword Analysis': 'Keyword Analysis',
  'Keyword Correlation': 'Keyword Correlation',
  'Keyword Included': 'Keyword Included',
  'Keyword Monitor': 'Keyword Monitor',
  'Keyword Related Reviews': 'Keyword Related Reviews',
  'Keyword Search': 'Keyword Search',
  'Keyword mentioned frequency': 'Keyword mentioned frequency',
  Keywords: 'Keywords',
  'Keywords &  words': 'Keywords &  words',
  'Keywords (Mentions)': 'Keywords (Mentions)',
  'Keywords Changes': 'Keywords Changes',
  'Keywords Type': 'Keywords Type',
  'Keyword Subscriptions': 'Keyword Subscriptions',
  Language: 'Language',
  'Language & Channel': 'Language & Channel',
  'Language Distribution': 'Language Distribution',
  'Language Distribution of Reviews': 'Language Distribution of Reviews',
  'Language Performance': 'Language Performance',
  'Language Settings': 'Language Settings',
  'Language distribution is calculated using all videos entering the all-time Top 500 within the selected period.':
    'Language distribution is calculated using all videos entering the all-time Top 500 within the selected period.',
  'Largest change contributor this week: {B} {A}. {B} {A}: {C}  change ({D} contribution).':
    'Largest change contributor this week: {B} {A}. {B} {A}: {C}  change ({D} contribution).',
  Last: 'Last',
  'Last 12 Months': 'Last 12 Months',
  'Last 12 Weeks': 'Last 12 Weeks',
  'Last 180 Days': 'Last 180 Days',
  'Last 24 Months': 'Last 24 Months',
  'Last 24 Weeks': 'Last 24 Weeks',
  'Last 3 Months': 'Last 3 Months',
  'Last 30 Days': 'Last 30 Days',
  'Last 365 Days': 'Last 365 Days',
  'Last 4 Weeks': 'Last 4 Weeks',
  'Last 6 Months': 'Last 6 Months',
  'Last 7 Days': 'Last 7 Days',
  'Last 90 Days': 'Last 90 Days',
  'Last Day Hourly Discuss Players': 'Last Day Hourly Discuss Players',
  'Last Day Hourly Mentions': 'Last Day Hourly Mentions',
  'Last Day Hourly Negative%': 'Last Day Hourly Negative%',
  'Last Day Mentions': 'Last Day Mentions',
  'Last Generate Time': 'Last Generate Time',
  'Last Month': 'Last Month',
  'Last Seen': 'Last Seen',
  'Last Week': 'Last Week',
  'Last Week-1': 'Last Week',
  Latest: 'Latest',
  'Latest Analysis Task Progress': 'Latest Analysis Task Progress',
  'Latest Update Time': 'Latest Update Time',
  Less: 'Less',
  'Lifetime Accum. Rating': 'Lifetime Accum. Rating',
  'Lifetime Added Reviews Positive%': 'Lifetime Added Reviews Positive%',
  'Lifetime Negative%': 'Lifetime Negative%',
  'Lifetime Rating': 'Lifetime Rating',
  'Lifetime Recommended%': 'Lifetime Recommended%',
  'Lifetime Reviews': 'Lifetime Reviews',
  'Lifetime Reviews-1': 'Lifetime Reviews',
  'Lifetime User Score': 'Lifetime User Score',
  'Lifetime. Rating & Reviews': 'Lifetime. Rating & Reviews',
  Like: 'Like',
  Likes: 'Likes',
  'Likes Change%': 'Likes Change%',
  'Likes by sentiment': 'Likes by sentiment',
  'Line chart': 'Line chart',
  Link: 'Link',
  'Live Broadcast Views': 'Live Broadcast Views',
  'Live Charts Analysis': 'Live Charts Analysis',
  'Live Chats': 'Live Chats',
  'Live Chats Analysis': 'Live Chats Analysis',
  'Live Chats Sentiment': 'Live Chats Sentiment',
  'Live Chats in {language} Language': 'Live Chats in {language} Language',
  'Live Chats on Streams': 'Live Chats on Streams',
  'Live Now': 'Live Now',
  'Live Stream Start Time': 'Live Stream Start Time',
  'Live Stream Start Time for The Game': 'Live Stream Start Time for The Game',
  'Live Stream Time': 'Live Stream Time',
  'Live Streaming Content Analysis': 'Live Streaming Content Analysis',
  'Live Today': 'Live Today',
  'Live stream': 'Live stream',
  Loading: 'Loading',
  'Loading...': 'Loading...',
  'Loading failed, please refresh the page.': 'Loading failed, please refresh the page.',
  Low: 'Low',
  MAU: 'MAU',
  MR: 'MR',
  'Macro (500K-1M)': 'Macro (500K-1M)',
  'Macro(500k ~ 1M)': 'Macro(500k ~ 1M)',
  Main: 'Main',
  'Main Change Tier 1 Topics': 'Main Change Tier 1 Topics',
  'Main Change Tier 2 Topics': 'Main Change Tier 2 Topics',
  'Main Change Topics': 'Main Change Topics',
  'Manual Edited Sentiment': 'Manual Edited Sentiment',
  March: 'March',
  Market: 'Market',
  'Market Popularity Ranking': 'Market Popularity Ranking',
  'Market Share by View': 'Market Share by View',
  'Market filter and Language filter are available. If you have any specific data calculation requirements, please feel free to contact {contact}.':
    'Market filter and Language filter are available. If you have any specific data calculation requirements, please feel free to contact {contact}.',
  'Marketing Hub': 'Marketing Hub',
  'Mass KOL': 'Mass KOL',
  'Max CCV': 'Max CCV',
  May: 'May',
  Medium: 'Medium',
  'Mega (1M+)': 'Mega (1M+)',
  'Mega(1M+)': 'Mega(1M+)',
  'Meme Details': 'Meme Details',
  'Meme Elements': 'Meme Elements',
  'Meme Trend': 'Meme Trend',
  'Meme Types': 'Meme Types',
  Memes: 'Memes',
  Mentions: 'Mentions',
  'Mentions & Brand Health': 'Mentions & Brand Health',
  'Mentions & DAU REV DLS': 'Mentions & DAU REV DLS',
  'Mentions & Engagement': 'Mentions & Engagement',
  'Mentions & Likes': 'Mentions & Likes',
  'Mentions & MAU REV DLS': 'Mentions & MAU REV DLS',
  'Mentions & Negative%': 'Mentions & Negative%',
  'Mentions & PCCV DigitalREV': 'Mentions & PCCV DigitalREV',
  'Mentions & PCU DigitalREV Units': 'Mentions & PCU DigitalREV Units',
  'Mentions & Sentiment': 'Mentions & Sentiment',
  'Mentions & Sentiment Trends': 'Mentions & Sentiment Trends',
  'Mentions & WAU REV DLS': 'Mentions & WAU REV DLS',
  'Mentions (Security-Related) Trend': 'Mentions (Security-Related) Trend',
  'Mentions ({dateType})': 'Mentions ({dateType})',
  'Mentions / DAU': 'Mentions / DAU',
  'Mentions / MAU': 'Mentions / MAU',
  'Mentions / WAU': 'Mentions / WAU',
  'Mentions Top 15 Topics': 'Mentions Top 15 Topics',
  'Mentions Top {top}': 'Mentions Top {top}',
  'Mentions Trend by Channel': 'Mentions Trend by Channel',
  'Mentions Trend by Language': 'Mentions Trend by Language',
  'Mentions by Subtopic': 'Mentions by Subtopic',
  'Mentions by Topic': 'Mentions by Topic',
  'Mentions by sentiment': 'Mentions by sentiment',
  'Mentions%': 'Mentions%',
  'Mentions%: Change%': 'Mentions%: Change%',
  'Mentions(change%)': 'Mentions(change%)',
  'Mentions: Change%': 'Mentions: Change%',
  'Mentions: Summary of the number of Reviews (Posts & Comments). This includes all reviews of the game in the App Store, as well as reviews captured on social media through monitor words and official accounts.':
    'Mentions: Summary of the number of Reviews (Posts & Comments). This includes all reviews of the game in the App Store, as well as reviews captured on social media through monitor words and official accounts.',
  'Mentions: Summary of the number of Reviews (Posts & Comments). This includes all reviews of the game in the Game Store, as well as reviews captured on Social Media through monitor keywords and official accounts.':
    'Mentions: Summary of the number of Reviews (Posts & Comments). This includes all reviews of the game in the Game Store, as well as reviews captured on Social Media through monitor keywords and official accounts.',
  'Mentions: not dedupilcated': 'Mentions: not dedupilcated',
  'Menu mismatch detected. If you have any questions, please contact {email}':
    'Menu mismatch detected. If you have any questions, please contact {email}',
  Metascore: 'Metascore',
  Metric: 'Metric',
  'Metric splitting not supported': 'Metric splitting not supported',
  'Metric/Engagement': 'Metric/Engagement',
  Metrics: 'Metrics',
  'Metrics Set': 'Metrics Set',
  'Metrics Settings': 'Metrics Settings',
  'Metrics Table for Download': 'Metrics Table for Download',
  'Micro (10K-50K)': 'Micro (10K-50K)',
  'Micro(10k ~ 50k)': 'Micro(10k ~ 50k)',
  'Mid-Tier (50K-500K)': 'Mid-Tier (50K-500K)',
  'Mid-Tier(50k ~ 500k)': 'Mid-Tier(50k ~ 500k)',
  'Min Correlation': 'Min Correlation',
  'Min Frequency': 'Min Frequency',
  Mixed: 'Mixed',
  'Mixed%': 'Mixed%',
  'Mixed-1': 'Mixed',
  MoM: 'MoM',
  Mobile: 'Mobile',
  'Mobile Games': 'Mobile Games',
  Mode: 'Mode',
  Module: 'Module',
  'Module Name': 'Module Name',
  Monday: 'Monday',
  'Monitor Account': 'Monitor Account',
  'Monitor Method': 'Monitor Method',
  'Monitor Scope': 'Monitor Scope',
  'Monitor Source': 'Monitor Source',
  'Monitor Way': 'Monitor Way',
  'Monitor Way: The opinion content from social media sources is obtained by crawlers through pre-configured monitoring keywords and monitoring social media accounts.\n\nKeyword Monitoring: Comments(Posts only) obtained by searching keywords on social media.\n\nAccount Monitoring: Comments(Posts&Replies) obtained by monitoring official accounts on social media.\n\nTopic: Divide comments into topics through the rules or algorithms.':
    'Monitor Way: The opinion content from social media sources is obtained by crawlers through pre-configured monitoring keywords and monitoring social media accounts.\n\nKeyword Monitoring: Comments(Posts only) obtained by searching keywords on social media.\n\nAccount Monitoring: Comments(Posts&Replies) obtained by monitoring official accounts on social media.\n\nTopic: Divide comments into topics through the rules or algorithms.',
  'Monitoring Source': 'Monitoring Source',
  Month: 'Month',
  'Month-1': 'Month',
  Monthly: 'Monthly',
  'Monthly Avg. DAU': 'Avg. DAU',
  'Monthly Avg. Download': 'Avg. Downloads',
  'Monthly Comment update': 'Monthly Comment update',
  'Monthly Returning': 'Monthly Returning',
  Months: 'Months',
  More: 'More',
  'More Filters': 'More Filters',
  'More Posts': 'More Posts',
  'More competitors will be added in the future.': 'More competitors will be added in the future.',
  'More than {days} days, till {time}': 'More than {days} days, till {time}',
  'Most Valuable': 'Most Valuable',
  'Mostly Negative': 'Mostly Negative',
  'Mostly Positive': 'Mostly Positive',
  'Multi-Gamer': 'Multi-Gamer',
  'Multiple words are separated by “;” .': 'Multiple words are separated by “;” .',
  'Must Have Keywords': 'Must Have Keywords',
  'Must be an integer.': 'Must be an integer.',
  'My Filter': 'My Filter',
  'My Following': 'My Following',
  'My Related': 'My Related',
  'My Reports': 'My Reports',
  'My Reports-1': 'My Reports',
  'NLP Generated': 'NLP Generated',
  'NLP Tag': 'NLP Tag',
  'Nano (1-10K)': 'Nano (1-10K)',
  'Nano(1K ~ 10K)': 'Nano(1K ~ 10K)',
  'Natural Language Search': 'Natural Language Search',
  'Natural Language Search Subscriptions': 'Natural Language Search Subscriptions',
  'Nearly {n} Hours': 'Nearly {n} Hours',
  Negative: 'Negative',
  'Negative Articles': 'Negative Articles',
  'Negative Content': 'Negative Content',
  'Negative Mentions': 'Negative Mentions',
  'Negative Ratio': 'Negative Ratio',
  'Negative Reviews': 'Negative Reviews',
  'Negative Topic': 'Negative Topic',
  'Negative%': 'Negative%',
  'Negative%-2': 'Negative%',
  'Negative%-2: Change%': 'Negative%: Change%',
  'Net Sentiment': 'Net Sentiment',
  'Network connection seems unstable. Please check your network settings or try again later.':
    'Network connection seems unstable. Please check your network settings or try again later.',
  Neutral: 'Neutral',
  'Neutral Articles': 'Neutral Articles',
  'Neutral%': 'Neutral%',
  'Neutral%-2': 'Neutral%',
  'Neutral%-2: Change%': 'Neutral%: Change%',
  New: 'New',
  'New Ads': 'New Ads',
  'New Creatives': 'New Creatives',
  'New Event': 'New Event',
  'New Event: Events occurring for the first time within 30 Days':
    'New Event: Events occurring for the first time within 30 Days',
  'New Prompt Applied': 'New Prompt Applied',
  News: 'News',
  'News Crawl Strategy': 'News Crawl Strategy',
  'News Crawlers': 'News Crawlers',
  'News Crawling Strategy': 'News Crawling Strategy',
  'News Media': 'News Media',
  'News Mentions': 'News Mentions',
  'News Mentions & Sentiment': 'News Mentions & Sentiment',
  'News crawling strategy: the crawler will use the game name & game alias to pair [news title] instead of [news title + content], the news whose title hits the game name will enter this game news database.':
    'News crawling strategy: the crawler will use the game name & game alias to pair [news title] instead of [news title + content], the news whose title hits the game name will enter this game news database.',
  'News-1': 'News',
  'News-2': 'News',
  Newsletter: 'Newsletter',
  Next: 'Next',
  'Next Star': 'Next Star',
  'Next report will be generated in {name}': 'Next report will be generated in {name}',
  Nikke: 'Nikke',
  No: 'No',
  'No Citation': 'No Citation',
  'No Data under the current filter settings.': 'No Data under the current filter settings.',
  'No GPT Report under current filter settings.': 'No GPT Report under current filter settings.',
  'No Keywords': 'No Keywords',
  'No New Data': 'No New Data',
  'No Steam data under current filter selections': 'No Steam data under current filter selections',
  'No Steam data yet': 'No Steam data yet',
  'No Tag': 'No Tag',
  'No Tags': 'No Tags',
  'No Title': 'No Title',
  'No URL': 'No URL',
  'No citation yet': 'No citation yet',
  'No comments yet.': 'No comments yet.',
  'No data': 'No data',
  'No data available for the selected period': 'No data available for the selected period',
  'No data for the current selection.': 'No data for the current selection.',
  'No data to load': 'No data to load',
  'No data under current filter selections': 'No data under current filter selections',
  'No data under current filter selections.': 'No data under current filter selections.',
  'No data under current selections.': 'No data under current selections.',
  'No data under the current filter settings.': 'No data under the current filter settings.',
  'No data yet': 'No data yet',
  'No data yet.': 'No data yet.',
  'No entities found by current keyword': 'No entities found by current keyword',
  'No filter available': 'No filter available',
  'No insight report has been created yet.': 'No insight report has been created yet.',
  'No more topics showed an increase': 'No more topics showed an increase',
  'No more topics showed an increase in mentions': 'No more topics showed an increase in mentions',
  'No more topics showed an increase in the indicator': 'No more topics showed an increase in the indicator',
  'No permission currently': 'No permission currently',
  'No result found': 'No result found',
  'No reviews have been crawled for this platform': 'No reviews have been crawled for this platform',
  'No sentiment score': 'No sentiment score',
  'No summary available yet': 'No summary available yet',
  'No topics showed an increase in mentions compared to the following periods':
    'No topics showed an increase in mentions compared to the following periods',
  'No topics showed an increase in the indicator compared to the following periods':
    'No topics showed an increase in the indicator compared to the following periods',
  'Non Negative %: The proportion of Positive and Neutral sentiment Reviews in total Reviews (Posts & Comments).':
    'Non Negative %: The proportion of Positive and Neutral sentiment Reviews in total Reviews (Posts & Comments).',
  'Non Negative%': 'Non Negative%',
  'Non-official Account': 'Non-official Account',
  'Non-streaming Influencers': 'Non-streaming Influencers',
  None: 'None',
  'None-1': 'None',
  'North America': 'North America',
  'Not Recommended': 'Not Recommended',
  'Not Released': 'Not Released',
  'Not yet edited': 'Not yet edited',
  Note: 'Note',
  'Note: Format restrictions or specific template requests may cause processing issues.':
    'Note: Format restrictions or specific template requests may cause processing issues.',
  'Note: The extended search currently only supports the "OR" search, which is the input of the ";" symbol.':
    'Note: The extended search currently only supports the "OR" search, which is the input of the ";" symbol.',
  Notice: 'Notice',
  'Not Recommended': 'Not Recommended',
  Noun: 'Noun',
  November: 'November',
  'Number of Creators': 'Number of Creators',
  'Number of Creators-1': 'Number of Creators',
  'Number of Live Chats': 'Number of Live Chats',
  'Number of Live Chats-1': 'Number of Live Chats',
  'Number of Reported Players': 'Number of Reported Players',
  'Number of Reviews': 'Number of Reviews',
  October: 'October',
  'Official Account': 'Official Account',
  'Official Account Data Performance': 'Official Account Data Performance',
  'Official Account Followers': 'Official Account Followers',
  'Official Account Performance Trends by Channel': 'Official Account Performance Trends by Channel',
  'Official Account User Comment Analysis': 'Official Account User Comment Analysis',
  'Official Account User Feedback Analysis': 'Official Account User Feedback Analysis',
  'Official Account VS Earned': 'Official Account VS Earned',
  'Official Account Views': 'Official Account Views',
  'Official Account-1': 'Official Account',
  'Official Accounts': 'Official Accounts',
  'Official Accounts Performance': 'Official Accounts Performance',
  'Official Engagement': 'Official Engagement',
  'Official Engagement Rate': 'Official Engagement Rate',
  'Official Potential Impressions': 'Official Potential Impressions',
  'Official Potential Impressions-1': 'Official Potential Impressions',
  'Official platform rating': 'Official platform rating',
  'On Record Time': 'On Record Time',
  'Once the newsletter is updated, we will notify you by email.':
    'Once the newsletter is updated, we will notify you by email.',
  'Once the report is created, the system will periodically update it automatically.\nPlease contact {email} if you need to create a periodic report.':
    'Once the report is created, the system will periodically update it automatically.\nPlease contact {email} if you need to create a periodic report.',
  'One-time Summary({total})': 'One-time Summary({total})',
  'Only 20 URLs can be added': 'Only 20 URLs can be added',
  'Only Contain': 'Only Contain',
  'Only Exclude': 'Only Exclude',
  'Only High Validation': 'Only High Validation',
  'Only Include': 'Only Include',
  'Only Me': 'Only Me',
  'Only counts original keywords': 'Only counts original keywords',
  'Only original keywords are counted': 'Only original keywords are counted',
  'Only single-day data summaries are supported.': 'Only single-day data summaries are supported.',
  'Only supports URLs within the last 90 days. Please reselect the date':
    'Only supports URLs within the last 90 days. Please reselect the date',
  'Only time ranges of 30 days or less are supported.': 'Only time ranges of 30 days or less are supported.',
  'Only you can view this report': 'Only you can view this report',
  'Opencritic/Metacritic Review Type': 'Opencritic/Metacritic Review Type',
  Operation: 'Operation',
  'Operation Metrics': 'Operation Metrics',
  'Operation Success': 'Operation Success',
  Opinions: 'Opinions',
  'Opinions Highlights': 'Opinions Highlights',
  'Opinions Introduction': 'Opinions Introduction',
  'Opinions Metrics': 'Opinions Metrics',
  'Opinions Overview': 'Opinions Overview',
  'Opinions Scources': 'Opinions Scources',
  'Opinions Sources': 'Opinions Sources',
  'Opinions Summary': 'Opinions Summary',
  Optional: 'Optional',
  'Optional keywords': 'Optional keywords',
  'Optional. If left blank, the pre-trained prompt provided by DataBrain will be used; alternatively, you can enter text to redefine the output format or further constrain the content of the summary.':
    'Optional. If left blank, the pre-trained prompt provided by DataBrain will be used; alternatively, you can enter text to redefine the output format or further constrain the content of the summary.',
  Order: 'Order',
  Organic: 'Organic',
  Original: 'Original',
  'Original Content': 'Original Content',
  'Original Language': 'Original Language',
  'Original Post': 'Original Post',
  'Original Report': 'Original Report',
  'Original URL': 'Original URL',
  'Original Content': 'Original Content',
  'Other KOLs': 'Other KOLs',
  'Other Settings': 'Other Settings',
  'Other Topics': 'Other Topics',
  'Other topics': 'Other topics',
  'Other videos': 'Other videos',
  Others: 'Others',
  'Output an opinion summary in English with no more than 300 words':
    'Output an opinion summary in English with no more than 300 words',
  Overall: 'Overall',
  'Overall Brand Health': 'Overall Brand Health',
  'Overall Performance': 'Overall Performance',
  'Overall Sentiment': 'Overall Sentiment',
  'Overall summary for the selected time period': 'Overall summary for the selected time period',
  Overview: 'Overview',
  'Overview Metrics': 'Overview',
  'Overview Table': 'Overview Table',
  'Overview of Opinions Data and Hot Topics': 'Overview of Opinions Data and Hot Topics',
  'Overwhelmingly Negative': 'Overwhelmingly Negative',
  'Overwhelmingly Positive': 'Overwhelmingly Positive',
  PC: 'PC',
  'PC/Console Games': 'PC/Console Games',
  PCU: 'PCU',
  PCV: 'PCV',
  PR: 'PR',
  'PUBGM Active': 'PUBGM Active',
  'PUBGM Esports Player': 'PUBGM Esports Player',
  'PUBGM Partnered': 'PUBGM Partnered',
  'PUBGM Potential': 'PUBGM Potential',
  PV: 'PV',
  Paid: 'Paid',
  'Parent Comment Id': 'Parent Comment Id',
  'Parent Comment Url': 'Parent Comment Url',
  'Part-of-speech': 'Part-of-speech',
  Partnered: 'Partnered',
  'Partnered%': 'Partnered%',
  'Partnered/Total': 'Partnered/Total',
  'Past 5-week Average': 'Past 5-week Average',
  Patch: 'Patch',
  'Patch/Version': 'Patch/Version',
  'Peak CCV': 'Peak CCV',
  'Peak CCV (Peak concurrent viewers): The daily peak viewers of the live stream is calculated according to the selected time range, and the maximum value of these days is taken as Peak CCV.':
    'Peak CCV (Peak concurrent viewers): The daily peak viewers of the live stream is calculated according to the selected time range, and the maximum value of these days is taken as Peak CCV.',
  'Peak CCV (Peak concurrent viewers): take the peak value of viewers watching the stream live.':
    'Peak CCV (Peak concurrent viewers): take the peak value of viewers watching the stream live.',
  'Peak Index': 'Peak Index',
  'Percentage of Official Posts': 'Percentage of Official Posts',
  'Percentage of UGC Posts': 'Percentage of UGC Posts',
  Performance: 'Performance',
  'Performance Analysis': 'Performance Analysis',
  'Performance-1': 'Performance',
  Period: 'Period',
  Permissions: 'Permissions',
  'Pie chart': 'Pie chart',
  Platform: 'Platform',
  'Playback Time': 'Playback Time',
  'Player Feedback': 'Player Feedback',
  'Players&Viewers': 'Players&Viewers',
  'Playtime on Record': 'Playtime on Record',
  'Please Input The Citation': 'Please Input The Citation',
  'Please choose an edition first.': 'Please choose an edition first.',
  'Please click <a>[Edit]</a> to follow games.': 'Please click <a>[Edit]</a> to follow games.',
  'Please contact @{contact}({email}) for configuration': 'Please contact @{contact}({email}) for configuration',
  'Please do not close the tabs during the download process.':
    'Please do not close the tabs during the download process.',
  'Please do not close this page - download.': 'Please do not close this page.',
  'Please do not close this page.': 'Please do not close this page.',
  'Please enter': 'Please enter',
  'Please enter a Email': 'Please enter a Email',
  'Please enter a name': 'Please enter a name',
  'Please enter a name for report': 'Please enter a name for report',
  'Please enter a name for this report': 'Please enter a name for this report',
  'Please enter a numerical value to three decimal places.': 'Please enter a numerical value to three decimal places.',
  'Please enter a report name': 'Please enter a report name',
  'Please enter correct date': 'Please enter correct date',
  'Please enter email title.': 'Please enter email title.',
  'Please enter in the following format: Tags: keywords, keywords; Tags: keywords, keywords. Use (;) to separate tags, and do not use (;) at the end of the last tag.':
    'Please enter in the following format: Tags: keywords, keywords; Tags: keywords, keywords. Use (;) to separate tags, and do not use (;) at the end of the last tag.',
  'Please enter keywords according to the format requirements':
    'Please enter keywords according to the format requirements',
  'Please enter name': 'Please enter name',
  'Please enter numbers, symbols are not supported.': 'Please enter numbers, symbols are not supported.',
  'Please enter prompt.': 'Please enter prompt.',
  'Please enter tags according to the format requirements': 'Please enter tags according to the format requirements',
  'Please enter the correct email address': 'Please enter the correct email address',
  'Please enter the module name': 'Please enter the module name',
  'Please enter the translation': 'Please enter the translation',
  'Please enter the version name': 'Please enter the version name',
  'Please fill in': 'Please fill in',
  'Please input a name for this report': 'Please input a name for this report',
  'Please input the tag': 'Please input the tag',
  'Please input the {topic_name} and {topic_definition} here. These two fields are compulsory. Additionally, you may choose to provide some keywords and example sentences related to the topic; these two fields are optional.':
    'Please input the {topic_name} and {topic_definition} here. These two fields are compulsory. Additionally, you may choose to provide some keywords and example sentences related to the topic; these two fields are optional.',
  'Please modify before submitting': 'Please modify before submitting',
  'Please re-select the filter': 'Please re-select the filter',
  'Please reserve a sentiment icon': 'Please reserve a sentiment icon',
  'Please reserve one option': 'Please reserve one option',
  'Please retry after changing the filter conditions.': 'Please retry after changing the filter conditions.',
  'Please search and select the Steam ID': 'Please search and select the Steam ID',
  'Please search and select the keywords': 'Please search and select the keywords',
  'Please search and select the reviewer': 'Please search and select the reviewer',
  'Please search and then select a URL': 'Please search and then select a URL',
  'Please select a Tag': 'Please select a Tag',
  'Please select a game': 'Please select a game',
  'Please select a metric': 'Please select a metric',
  'Please select a time range within {N} days': 'Please select a time range within {N} days',
  'Please select at least one game': 'Please select at least one game',
  'Please select the time range within 3 year. Feel free to contact {contact} if needed':
    'Please select the time range within 3 year. Feel free to contact {contact} if needed',
  'Please select {count} items at most for the best visualization experience.':
    'Please select {count} items at most for the best visualization experience.',
  'Please try again later.': 'Please try again later.',
  'Please try again tomorrow or contact {name} for more usage.':
    'Please try again tomorrow or contact {name} for more usage.',
  'Please try another keyword or search on other tables for the information you are looking for.':
    'Please try another keyword or search on other tables for the information you are looking for.',
  Popular: 'Popular',
  Popularity: 'Popularity',
  Position: 'Position',
  Positive: 'Positive',
  'Positive Articles': 'Positive Articles',
  'Positive Content': 'Positive Content',
  'Positive Mentions': 'Positive Mentions',
  'Positive Ratio': 'Positive Ratio',
  'Positive Reviews': 'Positive Reviews',
  'Positive Topic': 'Positive Topic',
  'Positive and': 'Positive and',
  'Positive%': 'Positive%',
  'Positive% & Negative%': 'Positive% & Negative%',
  'Positive% Difference': 'Positive% Difference',
  'Positive% by Language': 'Positive% by Language',
  'Positive%-2': 'Positive%',
  'Positive%-2: Change%': 'Positive%: Change%',
  'Positive%-3': 'Positive%',
  'Post Analysis': 'Post Analysis',
  'Post Comments': 'Post Comments',
  'Post Count': 'Post Count',
  'Post Engagement': 'Post Engagement',
  'Post Engagements': 'Post Engagements',
  'Post Influencers': 'Post Influencers',
  'Post Likes': 'Post Likes',
  'Post Publications': 'Post Publications',
  'Post Share': 'Share',
  'Post Views': 'Post Views',
  'Posting Time': 'Posting Time',
  'Postive% by Language': 'Postive% by Language',
  Posts: 'Posts',
  'Posts & Comments': 'Posts & Comments',
  'Posts-1': 'Posts',
  'Posts-2': 'Posts',
  Potential: 'Potential',
  'Potential Impressions': 'Potential Impressions',
  'Potential Impressions-1': 'Potential Impressions',
  'Potential Reach': 'Potential Reach',
  'Powered by iMarketing, contact bourneli@global.tencent.com for further questions':
    'Powered by iMarketing, contact bourneli@global.tencent.com for further questions',
  'Pre-configured': 'Pre-configured',
  'Pre-configured & NLP Algorithms': 'Pre-configured & NLP Algorithms',
  'Predicted DAU': 'Predicted DAU',
  'Predicted Download': 'Predicted Download',
  'Predicted MAU': 'Predicted MAU',
  'Predicted Revenue': 'Predicted Revenue',
  'Predicted WAU': 'Predicted WAU',
  'Preparing the summary task': 'Preparing the summary task',
  "Pressing 'Enter' will return.": "Pressing 'Enter' will return.",
  'Pressing ‘Enter’ will return': 'Pressing ‘Enter’ will return',
  'Pressing ‘Enter’ will return to the original list.': 'Pressing ‘Enter’ will return to the original list.',
  Preview: 'Preview',
  Previous: 'Previous',
  'Previous Period Mentions': 'Previous Period Mentions',
  'Previous Period Mentions-1': 'Previous Period Mentions',
  'Previous period': 'Previous period',
  'Private Discord': 'Private Discord',
  'Private Source': 'Private Source',
  Processing: 'Processing',
  Promoted: 'Promoted',
  Prompt: 'Prompt',
  'Prompt Modification': 'Prompt Modification',
  'Prompt Name': 'Prompt Name',
  'Prompt Setting': 'Prompt Setting',
  'Prompt deleted successfully': 'Prompt deleted successfully',
  'Prompt edit failed': 'Prompt edit failed',
  'Prompt edit successful': 'Prompt edit successful',
  'Prompt save failed': 'Prompt save failed',
  'Prompt saved successfully': 'Prompt saved successfully',
  'Prompt updated successfully': 'Prompt updated successfully',
  Prompts: 'Prompts',
  'Provides insights into overall game ratings and changes in game stores worldwide':
    'Provides insights into overall game ratings and changes in game stores worldwide',
  Publication: 'Publication',
  'Publication Counts': 'Publication Counts',
  Publications: 'Publications',
  'Publish Calendar': 'Publish Calendar',
  'Published Time': 'Published Time',
  'Publishing Performance': 'Publishing Performance',
  'Purchase Analysis': 'Purchase Analysis',
  'Quality Check:': 'Quality Check:',
  'Quarterly Returning': 'Quarterly Returning',
  Query: 'Query',
  'Questionnaire Feedback': 'Questionnaire Feedback',
  Quick: 'Quick',
  'Quick — faster, with fewer opinions and rougher numbers.':
    'Quick — faster, with fewer opinions and rougher numbers.',
  'Quick-1': 'Quick',
  Rank: 'Rank',
  'Rank Change': 'Rank Change',
  'Ranked By': 'Ranked By',
  'Ranked By {value}': 'Ranked By {value}',
  Rate: 'Rate',
  Rating: 'Rating',
  'Rating Difference': 'Rating Difference',
  'Rating Reviews': 'Rating Reviews',
  'Rating Settings': 'Rating Settings',
  'Rating-1': 'Rating',
  'Rating-2': 'Rating',
  'Rating-2%': 'Rating%',
  Ratings: 'Ratings',
  'Ratings by Language': 'Ratings by Language',
  'Ratings-1': 'Ratings',
  'Ratings-2': 'Ratings',
  Reach: 'Reach',
  'Reactions-1': 'Reactions',
  'Real examples/keywords': 'Real examples/keywords',
  'Real-Time AI Summary': 'Real-Time AI Summary',
  'Real-Time Ratings Across Global Game Stores': 'Real-Time Ratings Across Global Game Stores',
  'Real-time Opinions': 'Real-time Opinions',
  'Real-time Streaming': 'Real-time Streaming',
  'Real-time Streaming Analysis': 'Real-time Streaming Analysis',
  'Real-time Trend Analysis': 'Real-time Trend Analysis',
  'Real-time monitoring of worldwide social media, game stores, and news media':
    'Real-time monitoring of worldwide social media, game stores, and news media',
  'Realtime Accumulated Steam Reviews(1h)': 'Realtime Accumulated Steam Reviews(1h)',
  'Realtime Newly Added': 'Realtime Newly Added',
  'Realtime Ratings': 'Realtime Ratings',
  'Realtime Steam Reviews': 'Realtime Steam Reviews',
  Reason: 'Reason',
  'Receiver Email': 'Receiver Email',
  'Recent Accum. Rating': 'Recent Accum. Rating',
  'Recent Recommended%': 'Recent Recommended%',
  'Recent Reviews': 'Recent Reviews',
  'Recent Reviews Positive%': 'Recent Reviews Positive%',
  'Recent Reviews Positive%-1': 'Recent Reviews Positive%',
  'Recent Top News': 'Recent Top News',
  'Recent Viewed': 'Recent Viewed',
  Recommend: 'Recommend',
  Recommended: 'Recommended',
  'Recommended%': 'Recommended%',
  'Recommended%-1': 'Recommended%',
  'Refine topic definitions based on real game data': 'Refine topic definitions based on real game data',
  'Refreshed every 30 Mins, the first summary is being generated.':
    'Refreshed every 30 Mins, the first summary is being generated.',
  'Refund Game': 'Refund Game',
  Refunded: 'Refunded',
  Regenerate: 'Regenerate',
  'Regenerate AI Summary': 'Regenerate AI Summary',
  'Regenerate GPT Summary': 'Regenerate GPT Summary',
  Region: 'Region',
  'Region / Country': 'Region / Country',
  'Region/Country': 'Region/Country',
  'Regular Listening': 'Regular Listening',
  'Related Ads': 'Related Ads',
  'Related Creatives': 'Related Creatives',
  'Related Hashtags': 'Related Hashtags',
  'Related Links': 'Related Links',
  'Related News': 'Related News',
  'Related Queries': 'Related Queries',
  'Related Topic': 'Related Topic',
  'Related Topics': 'Related Topics',
  'Related Twitter': 'Related Twitter',
  'Related Videos': 'Related Videos',
  'Related keywords': 'Related keywords',
  'Related to the Game': 'Related to the Game',
  Release: 'Release',
  'Release Date': 'Release Date',
  'Release Days': 'Release Days',
  'Release Time': 'Release Time',
  'Release-1': 'Release',
  Relevance: 'Relevance',
  Remarks: 'Remarks',
  'Remove contrast item': 'Remove contrast item',
  'Remove from Favorites': 'Remove from Favorites',
  'Remove this game': 'Remove this game',
  'Removed duplicate reviews': 'Removed duplicate reviews',
  'Repeat Date Range': 'Repeat Date Range',
  'Repeat End Time': 'Repeat End Time',
  'Repeat every {number} {dateType}, data spans from 00:00 on the first day of Month 1 to 00:00 on the first day of Month {totalDiff}':
    'Repeat every {number} {dateType}, data spans from 00:00 on the first day of Month 1 to 00:00 on the first day of Month {totalDiff}',
  'Repeat every {number} {dateType}, data spans from 00:00 on {dateTypeText} 1 to 00:00 on {dateTypeText} {totalDiff}':
    'Repeat every {number} {dateType}, data spans from 00:00 on {dateTypeText} 1 to 00:00 on {dateTypeText} {totalDiff}',
  'Repeat every {number} {hour}': 'Repeat every {number} {hour}',
  'Replace current prompt?': 'Replace current prompt?',
  'Replacing it with "{title}" will lose the current text.': 'Replacing it with "{title}" will lose the current text.',
  Replies: 'Replies',
  Report: 'Report',
  'Report Language': 'Report Language',
  'Report Name': 'Report Name',
  'Report Start Time': 'Report Start Time',
  'Report Text': 'Report Text',
  'Report Text in Chinese': 'Report Text in Chinese',
  'Report Text in English': 'Report Text in English',
  'Report Time': 'Report Time',
  'Report Type': 'Report Type',
  'Report generation failed. Please contact {email}.': 'Report generation failed. Please contact {email}.',
  'Report generation success.': 'Report generation success.',
  'Report image download failed. Please refresh the page and try again.':
    'Report image download failed. Please refresh the page and try again.',
  'Report link copied': 'Report link copied',
  'Report permissions have been successfully adjusted.': 'Report permissions have been successfully adjusted.',
  'Report visibility has been set to "Visible only to me"; click {permission} to adjust.':
    'Report visibility has been set to "Visible only to me"; click {permission} to adjust.',
  'Report visibility has been set to "Visible to everyone"; click {permission} to adjust.':
    'Report visibility has been set to "Visible to everyone"; click {permission} to adjust.',
  'Report visibility has been set to "Visible to selected users"; click {permission} to adjust.':
    'Report visibility has been set to "Visible to selected users"; click {permission} to adjust.',
  Reportopenid: 'Reportopenid',
  'Representative Reviews': 'Representative Reviews',
  Reset: 'Reset',
  'Reset summary failed': 'Reset summary failed',
  'Reset summary success': 'Reset summary success',
  'Result Output': 'Result Output',
  Revenue: 'Revenue',
  'Revert to original report': 'Revert to original report',
  'Review Type': 'Review Type',
  'Review Type:': 'Review Type:',
  Reviewer: 'Reviewer',
  Reviewers: 'Reviewers',
  Reviews: 'Reviews',
  'Reviews Positive%': 'Reviews Positive%',
  'Reviews Rating': 'Reviews Rating',
  'Reviews Type: Posts': 'Reviews Type: Posts',
  'Reviews Type: Posts & Comments': 'Reviews Type: Posts & Comments',
  'Reviews are sourced from the DataBrain crawler': 'Reviews are sourced from the DataBrain crawler',
  'Reviews are sourced from the DataBrain crawler and statistically analyzed by language detection':
    'Reviews are sourced from the DataBrain crawler and statistically analyzed by language detection',
  'Reviews by Language': 'Reviews by Language',
  'Reviews in Chinese': 'Reviews in Chinese',
  'Reviews in Chinese(Total items: {total})': 'Reviews in Chinese(Total items: {total})',
  'Reviews in English': 'Reviews in English',
  'Reviews in English(Total items: {total})': 'Reviews in English(Total items: {total})',
  'Reviews in Original Language': 'Reviews in Original Language',
  'Reviews in Original Language(Total items: {total})': 'Reviews in Original Language(Total items: {total})',
  'Reviews-1': 'Reviews',
  'Reviews-2': 'Reviews',
  'Reviews-3': 'Reviews',
  'Reviews-4': 'Reviews',
  'Reviews-4%': 'Reviews%',
  Rising: 'Rising',
  'Rising Events': 'Rising Events',
  'Rising Event：Events with an increase of 80% or more in comments compared to the previous day':
    'Rising Event：Events with an increase of 80% or more in comments compared to the previous day',
  'Rising Keywords': 'Rising Keywords',
  'Rising Keywords-1': 'Rising Keywords',
  'Rising Topics': 'Rising Topics',
  'Risk Type': 'Risk Type',
  'Rules for Main Change Topics: In the left topic line chart, calculate the change rate of the start date and end date of all topics under the current indicator, and take the top three topics as the main change topics. If the date is set to one day, one week, or one month, the change rate between the date and the previous day, one week, or one month is calculated.':
    'Rules for Main Change Topics: In the left topic line chart, calculate the change rate of the start date and end date of all topics under the current indicator, and take the top three topics as the main change topics. If the date is set to one day, one week, or one month, the change rate between the date and the previous day, one week, or one month is calculated.',
  SDLW: 'SDLW',
  'SEA Hero Summary': 'SEA Hero Summary',
  SHLD: 'SHLD',
  SMLY: 'SMLY',
  SWLM: 'SWLM',
  'Same Day Last Week': 'Same Day Last Week',
  'Same Start Date (Including Align to Release)': 'Same Start Date (Including Align to Release)',
  Saturday: 'Saturday',
  Save: 'Save',
  'Save Current': 'Save Current',
  'Save Filter Setting': 'Save Filter Setting',
  'Save Report': 'Save Report',
  'Save Report-1': 'Save Report',
  'Save to "Summary List"': 'Save to "Summary List"',
  'Save to Analysis List': 'Save to Analysis List',
  'Save to Analysis list and view later': 'Save to Analysis list and view later',
  'Save to Summary list and view later': 'Save to Summary list and view later',
  'Save to System': 'Save to System',
  'Save to {page}': 'Save to {page}',
  'Saved Analysis List': 'Saved Analysis List',
  'Saved Prompts': 'Saved Prompts',
  'Saved failed': 'Saved failed',
  'Saved setting can be used in all filters in Opinions': 'Saved setting can be used in all filters in Opinions',
  'Saved settings can only be used in the filters on this page.':
    'Saved settings can only be used in the filters on this page.',
  'Saved successfully': 'Saved successfully',
  'Scatter chart': 'Scatter chart',
  'Score Change': 'Score Change',
  'Score Change%': 'Score Change%',
  'Score Filter': 'Score Filter',
  'Score Trends': 'Score Trends',
  'Score Value': 'Score Value',
  'Scraping failed': 'Scraping failed',
  'Scraping failed, the historical data will be displayed by default':
    'Scraping failed, the historical data will be displayed by default',
  Search: 'Search',
  'Search AI Tags': 'Search AI Tags',
  'Search Analysis Name': 'Search Analysis Name',
  'Search Analysis Name or Creator': 'Search Analysis Name or Creator',
  'Search Any Game in the table': 'Search Any Game in the table',
  'Search Creative title or body': 'Search Creative title or body',
  'Search Hashtag': 'Search Hashtag',
  'Search Influencer name.': 'Search Influencer name.',
  'Search Memes': 'Search Memes',
  'Search Recommendation': 'Search Recommendation',
  'Search Result': 'Search Result',
  'Search Trends': 'Search Trends',
  'Search any game': 'Search any game',
  'Search any game in the following table': 'Search any game in the following table',
  'Search any game in the following table.': 'Search any game in the following table.',
  'Search any metric in the table': 'Search any metric in the table',
  'Search by crawler': 'Search by crawler',
  'Search by keywords or phrases.': 'Search by keywords or phrases.',
  'Search by metrics': 'Search by metrics',
  'Search by source': 'Search by source',
  'Search for keywords from the user preconfigured keywords table':
    'Search for keywords from the user preconfigured keywords table',
  'Search for keywords from the user preconfigured keywords table and the NLP keywords library':
    'Search for keywords from the user preconfigured keywords table and the NLP keywords library',
  'Search for more keywords': 'Search for more keywords',
  'Search for reviews': 'Search for reviews',
  'Search for reviews by keywords or phrase': 'Search for reviews by keywords or phrase',
  'Search for reviews by keywords or phrases.': 'Search for reviews by keywords or phrases.',
  'Search hashtag': 'Search hashtag',
  'Search index(Last Day)': 'Search index(Last Day)',
  'Search index(Today)': 'Search index(Today)',
  'Search influencer name': 'Search influencer name',
  'Search news headline by original keyword or phrase': 'Search news headline by original keyword or phrase',
  'Search news headlines by keyword or phrase': 'Search news headlines by keyword or phrase',
  'Search pages': 'Search pages',
  'Search reviews with these keyword combinations (examples)':
    'Search reviews with these keyword combinations (examples)',
  'Search reviews with these keyword combinations.': 'Search reviews with these keyword combinations.',
  'Search streamer/title/URL': 'Search streamer/title/URL',
  'Search video': 'Search video',
  'Search video name': 'Search video name',
  Searches: 'Searches',
  Season: 'Season',
  'Second Correlation Words': 'Second Correlation Words',
  Security: 'Security',
  'Security Channel': 'Security Channel',
  'Security Mentions': 'Security Mentions',
  'Security Weekly Report': 'Security Weekly Report',
  'Security-Related Mentions': 'Security-Related Mentions',
  'Security-Related Mentions Weekly Report': 'Security-Related Mentions Weekly Report',
  'Segmentation & Tags': 'Segmentation & Tags',
  'Segmentation Distribution': 'Segmentation Distribution',
  'Select All': 'Select All',
  'Select Top 20 items': 'Select Top 20 items',
  'Select from system-recommended keywords, including translations and synonyms, for quick results.':
    'Select from system-recommended keywords, including translations and synonyms, for quick results.',
  Selected: 'Selected',
  'Selected AVG. Rating': 'Selected AVG. Rating',
  'Selected AVG. Rating & Reviews': 'Selected AVG. Rating & Reviews',
  'Selected AVG. Rating (T-2)': 'Selected AVG. Rating (T-2)',
  "Selected AVG. Rating displays yesterday's Rating by default and Lifetime Accum.Rating displays today's rating.":
    "Selected AVG. Rating displays yesterday's Rating by default and Lifetime Accum.Rating displays today's rating.",
  'Selected Filters': 'Selected Filters',
  'Selected Keywords': 'Selected Keywords',
  'Selected Positive%': 'Selected Positive%',
  'Selected Recommended%': 'Selected Recommended%',
  'Selected Reviews': 'Selected Reviews',
  'Selected Reviews-1': 'Selected Reviews',
  'Selected User Score': 'Selected User Score',
  'Selected Users': 'Selected Users',
  'Selected users can view this report in AI Task Center': 'Selected users can view this report in AI Task Center',
  'Selected:': 'Selected:',
  'Selected: {language} - {comment}': 'Selected: {language} - {comment}',
  'Selling Points': 'Selling Points',
  'Sending Mailbox': 'Sending Mailbox',
  'Sensor Tower DAU': 'Sensor Tower DAU',
  'Sensor Tower Download': 'Sensor Tower Download',
  'Sensor Tower MAU': 'Sensor Tower MAU',
  'Sensor Tower Revenue': 'Sensor Tower Revenue',
  'Sensor Tower WAU': 'Sensor Tower WAU',
  Sentiment: 'Sentiment',
  'Sentiment & DAU REV DLS': 'Sentiment & DAU REV DLS',
  'Sentiment & MAU REV DLS': 'Sentiment & MAU REV DLS',
  'Sentiment & PCCV DigitalREV': 'Sentiment & PCCV DigitalREV',
  'Sentiment & PCU DigitalREV Units': 'Sentiment & PCU DigitalREV Units',
  'Sentiment & WAU REV DLS': 'Sentiment & WAU REV DLS',
  'Sentiment AVG': 'Sentiment AVG',
  'Sentiment Category': 'Sentiment Category',
  'Sentiment Criteria': 'Sentiment Criteria',
  'Sentiment Distribution': 'Sentiment Distribution',
  'Sentiment Editing': 'Sentiment Editing',
  'Sentiment Score': 'Sentiment Score',
  'Sentiment Sentences': 'Sentiment Sentences',
  'Sentiment Settings': 'Sentiment Settings',
  'Sentiment decrease': 'Sentiment decrease',
  'Sentiment increase': 'Sentiment increase',
  'Sentiment: Change%': 'Sentiment: Change%',
  'Sentiment: Sentiment score is to score the sentiment tendency of each comment through NLP algorithm and sentiment analysis, with a scale of 1-5. 5 is Positive, 3 is Neutral, 1 is Negative.':
    'Sentiment: Sentiment score is to score the sentiment tendency of each comment through NLP algorithm and sentiment analysis, with a scale of 1-5. 5 is Positive, 3 is Neutral, 1 is Negative.',
  'Sentiment: Sentiment score is used to score the sentiment tendency of each comment through NLP algorithm and sentiment analysis, on a scale of 1-5. Sentiment score greater than 3.5 is positive, score lower than 2.5 is negative, and score between 2.5-3.5 is neutral.':
    'Sentiment: Sentiment score is used to score the sentiment tendency of each comment through NLP algorithm and sentiment analysis, on a scale of 1-5. Sentiment score greater than 3.5 is positive, score lower than 2.5 is negative, and score between 2.5-3.5 is neutral.',
  'Sentiment Editing': 'Sentiment Editing',
  'Separate Multiple Reviewers With ",".': 'Separate Multiple Reviewers With ",".',
  'Separate Multiple Steam ID With ",".': 'Separate Multiple Steam ID With ",".',
  'Separate by Channel': 'Separate by Channel',
  'Separate by Country': 'Separate by Country',
  'Separate by Language': 'Separate by Language',
  'Separate by Reviews Rating': 'Separate by Reviews Rating',
  'Separate by Sentiment': 'Separate by Sentiment',
  'Separate by Time': 'Separate by Time',
  'Separate keywords using ( , )( ; )( 、) ( | ), or line breaks':
    'Separate keywords using ( , )( ; )( 、) ( | ), or line breaks',
  September: 'September',
  'Server Weekly': 'Server Weekly',
  Sessions: 'Sessions',
  'Set Comparison Time (Up to 4 games can be compared)': 'Set Comparison Time (Up to 4 games can be compared)',
  'Set competitors on the left side of the table, and check the comparison of opinion metrics and trends.':
    'Set competitors on the left side of the table, and check the comparison of opinion metrics and trends.',
  'Set display events': 'Set display events',
  'Set tagging time range and filter conditions': 'Set tagging time range and filter conditions',
  'Set the countries you are most concerned about and they will be displayed by default.':
    'Set the countries you are most concerned about and they will be displayed by default.',
  'Set the countries you want to focus on, and they will be displayed in the table by default, and this change takes effect for you only.':
    'Set the countries you want to focus on, and they will be displayed in the table by default, and this change takes effect for you only.',
  Setting: 'Setting',
  'Setting Name': 'Setting Name',
  Share: 'Share',
  'Share Report': 'Share Report',
  'Share of Security Mentions': 'Share of Security Mentions',
  'Share of Security Mentions (Security Mentions / Total Game Mentions)':
    'Share of Security Mentions (Security Mentions / Total Game Mentions)',
  'Share-1': 'Share',
  'Share-2': 'Share',
  'Shared With Me': 'Shared With Me',
  Shares: 'Shares',
  'Shares Change%': 'Shares Change%',
  'Shift down': 'Shift down',
  'Shift up': 'Shift up',
  Show: 'Show',
  'Show All': 'Show All',
  'Show All Comments of This Post': 'Show All Comments of This Post',
  'Show Anomaly Attribution': 'Show Anomaly Attribution',
  'Show Change%': 'Show Change%',
  'Show Channel': 'Show Channel',
  'Show Country': 'Show Country',
  'Show DoD': 'Show DoD',
  'Show Events': 'Show Events',
  'Show Keyword & Topic': 'Show Keyword & Topic',
  'Show Language': 'Show Language',
  'Show Less': 'Show Less',
  'Show Metrics': 'Show Metrics',
  'Show More': 'Show More',
  'Show Region': 'Show Region',
  'Show Representative Reviews': 'Show Representative Reviews',
  'Show Tagged Videos Only': 'Show Tagged Videos Only',
  'Show all tag': 'Show all tag',
  'Show comparison chart of column data. Comparison chart calculation method: Based on the maximum value of the column where the value resides,  use a bar chart to show the proportion of the value to the maximum value.':
    'Show comparison chart of column data. Comparison chart calculation method: Based on the maximum value of the column where the value resides,  use a bar chart to show the proportion of the value to the maximum value.',
  'Show event axis': 'Show event axis',
  'Show event bubbles': 'Show event bubbles',
  'Show graph': 'Show graph',
  'Show on page': 'Show on page',
  'Show ranking among competitors': 'Show ranking among competitors',
  'Show top {number} mentions topics only': 'Show top {number} mentions topics only',
  'ShowChange%-1': 'Show Change%',
  'Similar Games': 'Similar Games',
  'Simplified Chinese': 'Simplified Chinese',
  'Social Media': 'Social Media',
  'Social Media Comments': 'Social Media Comments',
  'Social Media Metrics Details': 'Social Media Metrics Details',
  Sorry: 'Sorry',
  'Sorry, the export limit is set to {value} rows.': 'Sorry, the export limit is set to {value} rows.',
  'Sort By': 'Sort By',
  'Sort all influencers (time-consuming)': 'Sort all influencers (time-consuming)',
  'Sort by': 'Sort by',
  'Sort by Mentions': 'Sort by Mentions',
  'Sort by Mentions DoD': 'Sort by Mentions DoD',
  'Sort by Relevance': 'Sort by Relevance',
  'Sort by Sentiment': 'Sort by Sentiment',
  'Sort by Sentiment DoD': 'Sort by Sentiment DoD',
  'Sort by {name}': 'Sort by {name}',
  'Sort by {name} Change%': 'Sort by {name} Change%',
  'Sort influencers with more than 5K followers (faster)': 'Sort influencers with more than 5K followers (faster)',
  Source: 'Source',
  'Source Feature': 'Source Feature',
  'Source URL': 'Source URL',
  'Southeast Asia': 'Southeast Asia',
  'Specific Categories': 'Specific Categories',
  'Spotlight Reports': 'Spotlight Reports',
  Spreading: 'Spreading',
  'Spreading – Attention Required': 'Spreading – Attention Required',
  Stable: 'Stable',
  'Stable – Monitor Only': 'Stable – Monitor Only',
  'Stacked Table': 'Stacked Table',
  'Stacked chart': 'Stacked chart',
  'Starred Positive Reviews': 'Starred Positive Reviews',
  'Starred Reviews': 'Starred Reviews',
  'Starred Tag': 'Starred Tag',
  'Start Time': 'Start Time',
  'Start immediately': 'Start immediately',
  'Start&End Date': 'Start&End Date',
  Statistics: 'Statistics',
  'Statistics are only collected on the content (Videos and posts) published by Influencer on this game, excluding content not related to the game.':
    'Statistics are only collected on the content (Videos and posts) published by Influencer on this game, excluding content not related to the game.',
  Stats: 'Stats',
  'Stats based on Top 500 Video by views': 'Stats based on Top 500 Video by views',
  Status: 'Status',
  'Stay on top of the latest trends across the global web, alerting users to potential risks and safeguarding game reputation.':
    'Stay on top of the latest trends across the global web, alerting users to potential risks and safeguarding game reputation.',
  'Steam Added Reviews': 'Steam Added Reviews',
  'Steam Analysis': 'Steam Analysis',
  'Steam Filtered Reviews': 'Steam Filtered Reviews',
  'Steam ID': 'Steam ID',
  'Steam PCU': 'Steam PCU',
  'Steam Performance': 'Steam Performance',
  'Steam Performance-1': 'Steam Performance',
  'Steam Players': 'Steam Players',
  'Steam Positive Rate': 'Steam Positive Rate',
  'Steam Purchase': 'Steam Purchase',
  'Steam Ratings': 'Steam Ratings',
  'Steam Related': 'Steam Related',
  'Steam Revenue': 'Steam Revenue',
  'Steam Review Positive%': 'Steam Review Positive%',
  'Steam Reviews': 'Steam Reviews',
  'Steam Reviews Summary': 'Steam Reviews Summary',
  'Steam Selected Reviews Positive%: Based on all Steam reviews crawled during the selected time period, and the proportion of positive reviews is calculated.':
    'Steam Selected Reviews Positive%: Based on all Steam reviews crawled during the selected time period, and the proportion of positive reviews is calculated.',
  Stop: 'Stop',
  'Stop Analysis?': 'Stop Analysis?',
  'Stop Repeat Task?': 'Stop Repeat Task?',
  'Stop failed': 'Stop failed',
  'Stop success': 'Stop success',
  'Stop {name}? This action will delete the analysis and is irreversible. Please proceed with caution.':
    'Stop {name}? This action will delete the analysis and is irreversible. Please proceed with caution.',
  'Stop {name}? This subscription will be canceled and cannot be undone. Please proceed with caution.':
    'Stop {name}? This subscription will be canceled and cannot be undone. Please proceed with caution.',
  'Stop-1': 'Stop',
  Stopped: 'Stopped',
  'Store Score': 'Store Score',
  Stream: 'Stream',
  'Stream Sessions': 'Stream Sessions',
  'Stream Start Time': 'Stream Start Time',
  'Stream Time': 'Stream Time',
  'Stream Titles': 'Stream Titles',
  Streamer: 'Streamer',
  'Streamer Sentiment': 'Streamer Sentiment',
  'Streamer Type': 'Streamer Type',
  "Streamer's Ongoing Topic": "Streamer's Ongoing Topic",
  Streamers: 'Streamers',
  Streaming: 'Streaming',
  'Streaming Influencers': 'Streaming Influencers',
  'Streaming Status': 'Streaming Status',
  Sub: 'Sub',
  'Sub Sentiment': 'Sub Sentiment',
  'Subcore: Competitor-Related': 'Subcore: Competitor-Related',
  Subscribe: 'Subscribe',
  Subscribed: 'Subscribed',
  Subscriber: 'Subscriber',
  'Subscription failure': 'Subscription failure',
  'Subscription successful.': 'Subscription successful.',
  'Subscription time': 'Subscription time',
  Subscriptions: 'Subscriptions',
  'Subscriptions({totalSubscriptions})': 'Subscriptions({totalSubscriptions})',
  'Subsequent updates will be triggered at the top of each hour.':
    'Subsequent updates will be triggered at the top of each hour.',
  'Subsequent updates will be triggered daily at 00:00 (UTC+8).':
    'Subsequent updates will be triggered daily at 00:00 (UTC+8).',
  'Subsequent updates will be triggered every 7 days at 00:00 (UTC+8).':
    'Subsequent updates will be triggered every 7 days at 00:00 (UTC+8).',
  Subtopic: 'Subtopic',
  'Subtopic Escalation': 'Subtopic Escalation',
  'Successfully Unsubscribed from AI Summary Emails': 'Successfully Unsubscribed from AI Summary Emails',
  'Successfully Unsubscribed from AI Summary WeCom Notification':
    'Successfully Unsubscribed from AI Summary WeCom Notification',
  'Successfully crawled {count} comments.': 'Successfully crawled {count} comments.',
  'Successfully saved analysis': 'Successfully saved analysis',
  Sum: 'Sum',
  'Sum (Keyword mentioned frequency)': 'Sum (Keyword mentioned frequency)',
  'Sum (Removed duplicate reviews)': 'Sum (Removed duplicate reviews)',
  'Sum (Topic mentioned frequency)': 'Sum (Topic mentioned frequency)',
  'Sum Airtime': 'Sum Airtime',
  'Sum Engagement': 'Sum Engagement',
  'Sum Hours Watched': 'Sum Hours Watched',
  'Sum Influencers': 'Sum Influencers',
  'Sum Volume': 'Sum Volume',
  'Sum of Rating': 'Sum of Rating',
  'Sum of Reviews': 'Sum of Reviews',
  'Sum of Reviews-1': 'Sum of Reviews',
  Summary: 'Summary',
  'Summary API is currently unstable, please try again': 'Summary API is currently unstable, please try again',
  'Summary Data Range': 'Summary Data Range',
  'Summary Detail': 'Summary Detail',
  'Summary End Time': 'Summary End Time',
  'Summary List': 'Summary List',
  'Summary Mode': 'Summary Mode',
  'Summary Name': 'Summary Name',
  'Summary Name CN': 'Summary Name CN',
  'Summary Name EN': 'Summary Name EN',
  'Summary Options': 'Summary Options',
  'Summary Ranking of Selected Channels': 'Summary Ranking of Selected Channels',
  'Summary Start Time': 'Summary Start Time',
  'Summary by 5-minutes intervals': 'Summary by 5-minutes intervals',
  'Summary failed': 'Summary failed',
  Sunday: 'Sunday',
  'Support Language': 'Support Language',
  'Switched to the latest date with data': 'Switched to the latest date with data',
  'Syntax examples': 'Syntax examples',
  'System Recommendations': 'System Recommendations',
  Table: 'Table',
  Tag: 'Tag',
  'Tag Analysis': 'Tag Analysis',
  'Tag filtered data with topics': 'Tag filtered data with topics',
  'Tagging failed': 'Tagging failed',
  Tags: 'Tags',
  'Tags Analysis': 'Tags Analysis',
  'Take the top 10 influencers with the number of followers on the whole channel. Followers source of each platform: Reddit is taken from Members, Youtube is taken from Subscribe, and other platforms are taken from Followers.':
    'Take the top 10 influencers with the number of followers on the whole channel. Followers source of each platform: Reddit is taken from Members, Youtube is taken from Subscribe, and other platforms are taken from Followers.',
  'Tap Tap': 'Tap Tap',
  'Task delivery failed.': 'Task delivery failed.',
  'Task generation failed, possibly due to the following reasons:':
    'Task generation failed, possibly due to the following reasons:',
  'Tencent Games': 'Tencent Games',
  Text: 'Text',
  'Text Posts': 'Text Posts',
  'The AI API is unstable, Please {btn}': 'The AI API is unstable, Please {btn}',
  'The AI summary is being generated and is expected to take 1 to 3 hours, depending on the content.':
    'The AI summary is being generated and is expected to take 1 to 3 hours, depending on the content.',
  'The AI summary report you have requested for the current game will be displayed on this page. (Excluding keyword and URL analysis)':
    'The AI summary report you have requested for the current game will be displayed on this page. (Excluding keyword and URL analysis)',
  'The AI summary task is in the queue, and the report content has not been generated yet.':
    'The AI summary task is in the queue, and the report content has not been generated yet.',
  'The AI tags are supported by the Data & AI team. For more information, please contact zhenquanlin@tencent.com.':
    'The AI tags are supported by the Data & AI team. For more information, please contact zhenquanlin@tencent.com.',
  'The Game Group has configured permission control for this page. ':
    'The Game Group has configured permission control for this page. ',
  'The Key Metrics page presents the performance of key metrics, the total mentions and sentiment of the opinions, and the comparison between the DAU and revenue trends.':
    'The Key Metrics page presents the performance of key metrics, the total mentions and sentiment of the opinions, and the comparison between the DAU and revenue trends.',
  'The Key Metrics page presents the performance of key metrics, the total mentions and sentiment of the opinions.':
    'The Key Metrics page presents the performance of key metrics, the total mentions and sentiment of the opinions.',
  'The Launch Day 1': 'The Launch Day 1',
  'The Launch Day 30': 'The Launch Day 30',
  'The Launch Day 7': 'The Launch Day 7',
  'The Lifetime Accumulative Reviews of Google Play does not distinguish between countries. The table only shows the number of reviews under the corresponding edition of countries.':
    'The Lifetime Accumulative Reviews of Google Play does not distinguish between countries. The table only shows the number of reviews under the corresponding edition of countries.',
  'The Performance page presents the performance of key metrics, the total mentions and sentiment of the opinions, and the comparison between the DAU and revenue trends.':
    'The Performance page presents the performance of key metrics, the total mentions and sentiment of the opinions, and the comparison between the DAU and revenue trends.',
  'The Performance page presents the performance of key metrics, the total mentions and sentiment of the opinions.':
    'The Performance page presents the performance of key metrics, the total mentions and sentiment of the opinions.',
  'The Summary page presents the clustered hot content based on the NLP algorithm. Click the events on the left to view the detailed reviews on the right.':
    'The Summary page presents the clustered hot content based on the NLP algorithm. Click the events on the left to view the detailed reviews on the right.',
  'The analysis is currently being generated. If you feel the task planning is inaccurate, you can pause at any time.':
    'The analysis is currently being generated. If you feel the task planning is inaccurate, you can pause at any time.',
  'The analysis will take 15 to 30 minutes to generate.': 'The analysis will take 15 to 30 minutes to generate.',
  'The countries displayed in Google Play reviews are obtained by crawling through the Google Play scores for each language and then mapping the language to the country.\nClick to see the National Language Mapping rule >':
    'The countries displayed in Google Play reviews are obtained by crawling through the Google Play scores for each language and then mapping the language to the country.\nClick to see the National Language Mapping rule >',
  'The current algorithm does not support event tracking. Please stay tuned for future updates.':
    'The current algorithm does not support event tracking. Please stay tuned for future updates.',
  'The current calculation time zone is UTC+8 time zone.': 'The current calculation time zone is UTC+8 time zone.',
  'The current game has low priority, and the original text is unavailable in Chinese translation. For any inquiries, please contact {email}.':
    'The current game has low priority, and the original text is unavailable in Chinese translation. For any inquiries, please contact {email}.',
  'The current position of this review': 'The current position of this review',
  'The data from each channel is currently updated hourly': 'The data from each channel is currently updated hourly',
  'The data has been mostly imported, and the change rate is relatively reliable.':
    'The data has been mostly imported, and the change rate is relatively reliable.',
  "The data is taken from Metacritic's official User Score data.":
    "The data is taken from Metacritic's official User Score data.",
  'The data of the selected date is insufficient, and no valid event is obtained.':
    'The data of the selected date is insufficient, and no valid event is obtained.',
  'The following content is provided by GPT and is for reference only':
    'The following content is provided by GPT and is for reference only',
  'The following keywords are clustered from news headlines and are not related to the main content of the news articles.':
    'The following keywords are clustered from news headlines and are not related to the main content of the news articles.',
  'The following reviews are sorted by engagements': 'The following reviews are sorted by engagements',
  'The following topics are clustered from news headlines and are not related to the main content of the news articles.':
    'The following topics are clustered from news headlines and are not related to the main content of the news articles.',
  'The frequency indicates the individual occurrence frequency of a keyword.\nFor example, in the sentence “love love love this game”, the word frequency of “Love” is 3.':
    'The frequency indicates the individual occurrence frequency of a keyword.\nFor example, in the sentence “love love love this game”, the word frequency of “Love” is 3.',
  'The game《{gameName}》has not been visited for a while, so data updates have been stopped to save resources. If you need to view the latest data, please contact {email} or submit your requirements in the "{feedback}" section at the top right of the navigation bar.':
    'The game《{gameName}》has not been visited for a while, so data updates have been stopped to save resources. If you need to view the latest data, please contact {email} or submit your requirements in the "{feedback}" section at the top right of the navigation bar.',
  'The hottest content based on NLP algorithm clustering': 'The hottest content based on NLP algorithm clustering',
  'The hour watched duration: the total duration from the time when users enter the live room to the time they leave.':
    'The hour watched duration: the total duration from the time when users enter the live room to the time they leave.',
  'The initial report includes a opinion summary. Subsequent updates will only refresh the topic tagging results. Please navigate to the Report Page to generate the summary on need.':
    'The initial report includes a opinion summary. Subsequent updates will only refresh the topic tagging results. Please navigate to the Report Page to generate the summary on need.',
  'The input data cannot exceed 100%': 'The input data cannot exceed 100%',
  'The keyword data statistics in this place adopt the original keyword list, which has not undergone the subsequent synthetic keyword processing, namely, it does not integrate synonymous keywords.':
    'The keyword data statistics in this place adopt the original keyword list, which has not undergone the subsequent synthetic keyword processing, namely, it does not integrate synonymous keywords.',
  'The large model selects valid reviews to summarize opinions, which may not cover all reviews.':
    'The large model selects valid reviews to summarize opinions, which may not cover all reviews.',
  'The memes are distilled by AI. Please use them as a reasonable reference. If you have any issues, please contact fduhuixinli@tencent.com.':
    'The memes are distilled by AI. Please use them as a reasonable reference. If you have any issues, please contact fduhuixinli@tencent.com.',
  'The mentions of the game are related to the monitoring configuration':
    'The mentions of the game are related to the monitoring configuration',
  'The minimum value must be {num}.': 'The minimum value must be {num}.',
  'The module for Partnered Streaming Influencers is not yet developed. Please Stay tuned for updates.':
    'The module for Partnered Streaming Influencers is not yet developed. Please Stay tuned for updates.',
  'The most discussed topic content based on the reviews labeled by topic classification':
    'The most discussed topic content based on the reviews labeled by topic classification',
  'The network is unstable. Failed to load filters. Please try again.':
    'The network is unstable. Failed to load filters. Please try again.',
  'The number of reports': 'The number of reports',
  'The options provided by this filter are all lists of Steam ID within the selected time period. When the selected time period is long, you may need to wait a while for the complete list of publishers to load.':
    'The options provided by this filter are all lists of Steam ID within the selected time period. When the selected time period is long, you may need to wait a while for the complete list of publishers to load.',
  'The options provided by this filter are all lists of reviewers within the selected time period. When the selected time period is long, you may need to wait a while for the complete list of publishers to load.':
    'The options provided by this filter are all lists of reviewers within the selected time period. When the selected time period is long, you may need to wait a while for the complete list of publishers to load.',
  'The page has been successfully added to the Favorite Page.':
    'The page has been successfully added to the Favorite Page.',
  'The page you are trying to access cannot be found. Please check the page link.':
    'The page you are trying to access cannot be found. Please check the page link.',
  "The percentage of positive reviews taken from Steam's official calculation.":
    "The percentage of positive reviews taken from Steam's official calculation.",
  'The previous corresponding period': 'The previous corresponding period',
  'The real-time data of the current day is displayed by default. If there is no data, please change the date filter to another date':
    'The real-time data of the current day is displayed by default. If there is no data, please change the date filter to another date',
  'The report generation has been manually stopped by the user.':
    'The report generation has been manually stopped by the user.',
  'The report has been manually stopped.': 'The report has been manually stopped.',
  'The report task has been created and saved to the AI Task Center. By default, it is visible only to you; you can adjust this by clicking on the {permission} settings.':
    'The report task has been created and saved to the AI Task Center. By default, it is visible only to you; you can adjust this by clicking on the {permission} settings.',
  'The report task has been created. By default, it is visible only to you; you can adjust this by clicking on the {permission} settings.':
    'The report task has been created. By default, it is visible only to you; you can adjust this by clicking on the {permission} settings.',
  'The report will be displayed on the AI Insights Report page':
    'The report will be displayed on the AI Insights Report page',
  'The report will be sent to this email automatically upon generation':
    'The report will be sent to this email automatically upon generation',
  'The score for the selected period has not been crawled yet.':
    'The score for the selected period has not been crawled yet.',
  'The selected tier1 topic will be displayed in the left-hand shortcut positioning area. \n\nThe selected tier2 topic will be displayed in the topic chart below, while any unselected tier2 topics under the tier1 topic will be hidden.':
    'The selected tier1 topic will be displayed in the left-hand shortcut positioning area. \n\nThe selected tier2 topic will be displayed in the topic chart below, while any unselected tier2 topics under the tier1 topic will be hidden.',
  'The sentiment score and translation of reviews can be modified, and the modification will take effect the next day.':
    'The sentiment score and translation of reviews can be modified, and the modification will take effect the next day.',
  'The sentiment score of each keyword was obtained by averaging the sentiment score of all comments corresponding to each keyword.\nKeywords with sentiment score less than 2.5 show red; between 2.5 to 3.5 show gray; greater than 3.5 show green.':
    'The sentiment score of each keyword was obtained by averaging the sentiment score of all comments corresponding to each keyword.\nKeywords with sentiment score less than 2.5 show red; between 2.5 to 3.5 show gray; greater than 3.5 show green.',
  'The sentiment score, channel, country, and language data of the news page have been updated since 2022-09-02. The keyword and topic data have been updated since 2023-05-30.':
    'The sentiment score, channel, country, and language data of the news page have been updated since 2022-09-02. The keyword and topic data have been updated since 2023-05-30.',
  'The server is currently busy or the resource is temporarily unavailable. Please try again later.':
    'The server is currently busy or the resource is temporarily unavailable. Please try again later.',
  "The system doesn't recognize the format of the link you entered. Please verify the link and try again.":
    "The system doesn't recognize the format of the link you entered. Please verify the link and try again.",
  'The system will refresh automatically every 30 minutes until the live stream ends':
    'The system will refresh automatically every 30 minutes until the live stream ends',
  'The update only refreshes the topic tagging results; please go to the report page to trigger the sentiment summary as needed.':
    'The update only refreshes the topic tagging results; please go to the report page to trigger the sentiment summary as needed.',
  'The value of Min Correlation must be more than {min} and less than {max}.':
    'The value of Min Correlation must be more than {min} and less than {max}.',
  'The versions are different, so dragging and dropping is not possible.':
    'The versions are different, so dragging and dropping is not possible.',
  'There are no AI analysis tasks at the moment.': 'There are no AI analysis tasks at the moment.',
  'There are no events scheduled for this period.': 'There are no events scheduled for this period.',
  'There are no following games.': 'There are no following games.',
  'There are no weekly reports at the moment.': 'There are no weekly reports at the moment.',
  'There is a delay in data updating, so the data on this page (such as views, interactions, likes, shares, comments, followers, etc.) are not realtime data.\nUpdate frequency:\nPosts from Monitor accounts will be updated once a day for up to 7 days.\nAmong posts from keyword sources, only posts on Youtube, Twitch and Tiktok channels are updated once a day, up to 7 days; Posts from other sources have no updates.':
    'There is a delay in data updating, so the data on this page (such as views, interactions, likes, shares, comments, followers, etc.) are not realtime data.\nUpdate frequency:\nPosts from Monitor accounts will be updated once a day for up to 7 days.\nAmong posts from keyword sources, only posts on Youtube, Twitch and Tiktok channels are updated once a day, up to 7 days; Posts from other sources have no updates.',
  'There is not enough data under the current filter to generate Hot Event.':
    'There is not enough data under the current filter to generate Hot Event.',
  "There's no data under the current search conditions": "There's no data under the current search conditions",
  'Third Party': 'Third Party',
  'This Hour': 'This Hour',
  'This Month': 'This Month',
  'This Week': 'This Week',
  'This Week-1': 'This Week',
  'This analysis report has been saved to the {page}': 'This analysis report has been saved to the {page}',
  'This analysis report has been saved.': 'This analysis report has been saved.',
  'This comment has no post.': 'This comment has no post.',
  "This date hasn't been tagged with AI Topics yet. Please pick one from the available tagged dates.":
    "This date hasn't been tagged with AI Topics yet. Please pick one from the available tagged dates.",
  'This game has been released for less than 30 days and currently does not have Recent Reviews Rating on Steam.':
    'This game has been released for less than 30 days and currently does not have Recent Reviews Rating on Steam.',
  'This game is not configured with NLP tasks, feel free to contact {contact} if you need.':
    'This game is not configured with NLP tasks, feel free to contact {contact} if you need.',
  'This game is not yet configured in the Opinions system. You can contact {email} to add this game.':
    'This game is not yet configured in the Opinions system. You can contact {email} to add this game.',
  'This link does not contain a Shortid, so the filter options cannot be displayed.':
    'This link does not contain a Shortid, so the filter options cannot be displayed.',
  'This page supports a maximum date range of 90 days. For longer-term game rankings, please visit {btn}.':
    'This page supports a maximum date range of 90 days. For longer-term game rankings, please visit {btn}.',
  'This page uses PMI (Pointwise Mutual Information) to measure the relevance of keywords.\nPMI is the ratio of the probability of two keywords co-occurring in the text to the product of their individual probabilities, and then taking the logarithm. It means that if two keywords x and y are independent, that is, unrelated, then their joint probability is equal to the product of their individual probabilities, and the PMI formula calculates a relevance result of zero.\nThe larger the PMI value, the more relevant the two keywords are, and the smaller the PMI value, the less relevant they are.':
    'This page uses PMI (Pointwise Mutual Information) to measure the relevance of keywords.\nPMI is the ratio of the probability of two keywords co-occurring in the text to the product of their individual probabilities, and then taking the logarithm. It means that if two keywords x and y are independent, that is, unrelated, then their joint probability is equal to the product of their individual probabilities, and the PMI formula calculates a relevance result of zero.\nThe larger the PMI value, the more relevant the two keywords are, and the smaller the PMI value, the less relevant they are.',
  'This post has no URL': 'This post has no URL',
  'This process will take 1 to 3 minutes, depending on the submitted content.':
    'This process will take 1 to 3 minutes, depending on the submitted content.',
  'This report will be saved to the {page} under the [AI Analysis Hub] menu.':
    'This report will be saved to the {page} under the [AI Analysis Hub] menu.',
  "This review don't have URL": "This review don't have URL",
  'This review has no url': 'This review has no url',
  'This time period': 'This time period',
  'This video cannot obtain subtitle content': 'This video cannot obtain subtitle content',
  'This video has no subtitles': 'This video has no subtitles',
  Thursday: 'Thursday',
  'Tier 1 Category': 'Tier 1 Category',
  'Tier 1 Tags': 'Tier 1 Tags',
  'Tier 1 Topic': 'Tier 1 Topic',
  'Tier 1 Topic Breakdown': 'Tier 1 Topic Breakdown',
  'Tier 2 Category': 'Tier 2 Category',
  'Tier 2 Tags': 'Tier 2 Tags',
  'Tier 2 Topic': 'Tier 2 Topic',
  'Tier 2 Topic Performance': 'Tier 2 Topic Performance',
  'Tier1Topic-1': 'Tier 1 Topic',
  'TikTok Videos': 'TikTok Videos',
  'TikTok Views': 'TikTok Views',
  'TikTok platform has not provided relevant data for the selected date, {button}.':
    'TikTok platform has not provided relevant data for the selected date, {button}.',
  'TikTok shorts': 'TikTok shorts',
  Time: 'Time',
  'Time (UTC+8)': 'Time (UTC+8)',
  'Time Interval': 'Time Interval',
  'Time Range': 'Time Range',
  'Time Settings': 'Time Settings',
  'Time(UTC+8:00)': 'Time(UTC+8:00)',
  'Time-1': 'Time',
  'Timeline of Mentions': 'Timeline of Mentions',
  'Timeline of Mentions & Sentiment': 'Timeline of Mentions & Sentiment',
  'Timeline of Sentiment': 'Timeline of Sentiment',
  'Timeline of Top 10 Mentions': 'Timeline of Top 10 Mentions',
  'Timeline of Top 15 Topics': 'Timeline of Top 15 Topics',
  Title: 'Title',
  'To avoid impacting system performance, Exact Search only supports batch queries of up to 200 keywords.':
    'To avoid impacting system performance, Exact Search only supports batch queries of up to 200 keywords.',
  'To avoid impacting system performance, Extended Search does not support + combination queries.':
    'To avoid impacting system performance, Extended Search does not support + combination queries.',
  'To avoid impacting system performance, Extended Search only supports batch queries of up to 20 keywords.':
    'To avoid impacting system performance, Extended Search only supports batch queries of up to 20 keywords.',
  'To be updated': 'To be updated',
  'To enhance search efficiency, the list only displays the top 100 keywords.':
    'To enhance search efficiency, the list only displays the top 100 keywords.',
  'To improve search efficiency, select up to 10 keywords': 'To improve search efficiency, select up to 10 keywords',
  Today: 'Today',
  'Top 1 Account': 'Top 1 Account',
  'Top 10 Mentions': 'Top 10 Mentions',
  'Top 10 Searches': 'Top 10 Searches',
  'Top 15 Topics': 'Top 15 Topics',
  'Top 15 Topics Ranked by ': 'Top 15 Topics Ranked by ',
  'Top 2 Account': 'Top 2 Account',
  'Top 3 Account': 'Top 3 Account',
  'Top 3 Reviews': 'Top 3 Reviews',
  'Top 30 Categories': 'Top 30 Categories',
  'Top 50 Hashtags': 'Top 50 Hashtags',
  'Top 50 Publications': 'Top 50 Publications',
  'Top 500 New Video Likes': 'Top 500 New Video Likes',
  'Top 500 New Video Views': 'Top 500 New Video Views',
  'Top Critic Average': 'Top Critic Average',
  'Top Posts by': 'Top Posts by',
  "Top contributors to this week's fluctuation: {A};": "Top contributors to this week's fluctuation: {A};",
  'Top10 Streamings': 'Top10 Streamings',
  'Top10 Videos': 'Top10 Videos',
  Topic: 'Topic',
  'Topic & Keyword': 'Topic & Keyword',
  'Topic / Keywords': 'Topic / Keywords',
  'Topic Analysis': 'Topic Analysis',
  'Topic Breakdown': 'Topic Breakdown',
  'Topic Definition': 'Topic Definition',
  'Topic Editing': 'Topic Editing',
  'Topic Keywords': 'Topic Keywords',
  'Topic Name': 'Topic Name',
  'Topic Performance': 'Topic Performance',
  'Topic Sentiment': 'Topic Sentiment',
  'Topic Summary': 'Topic Summary',
  'Topic Summary-1': 'Topic Summary',
  'Topic Tagging Model': 'Topic Tagging Model',
  'Topic Tagging:': 'Topic Tagging:',
  'Topic Tracking': 'Topic Tracking',
  'Topic Trend': 'Topic Trend',
  'Topic Trends': 'Topic Trends',
  'Topic mentioned frequency': 'Topic mentioned frequency',
  Topics: 'Topics',
  'Topics are pre-configured and can be applied to topic classification of reviews through keyword matching or algorithm models. Please contact @miamgao for topic configuration.':
    'Topics are pre-configured and can be applied to topic classification of reviews through keyword matching or algorithm models. Please contact @miamgao for topic configuration.',
  Total: 'Total',
  'Total Accounts': 'Total Accounts',
  'Total Articles': 'Total Articles',
  'Total Engagements on Active Ads': 'Total Engagements on Active Ads',
  'Total Impressions on Active Ads': 'Total Impressions on Active Ads',
  'Total Intent': 'Total Intent',
  'Total Likes': 'Total Likes',
  'Total Mentions': 'Total Mentions',
  'Total Mentions Change%': 'Total Mentions Change%',
  'Total Potential Impressions': 'Total Potential Impressions',
  'Total Publications': 'Total Publications',
  'Total Rating': 'Total Rating',
  'Total Report': 'Total Report',
  'Total Reviews': 'Total Reviews',
  'Total Sessions': 'Total Sessions',
  'Total Social Media': 'Total Social Media',
  'Total Summary': 'Total Summary',
  'Total Views': 'Total Views',
  'Total items': 'Total items',
  'Total-2': 'Total',
  'Total-3': 'Total',
  Translate: 'Translate',
  'Translate: ': 'Translate: ',
  'Translate: Chinese': 'Translate: Chinese',
  'Translate: English': 'Translate: English',
  'Translate: Original Language': 'Translate: Original Language',
  'Translation cannot be empty': 'Translation cannot be empty',
  'Tree Diagram': 'Tree Diagram',
  Trend: 'Trend',
  'Trend Comparison': 'Trend Comparison',
  'Trend Detail': 'Trend Detail',
  'Trend Topic': 'Trend Topic',
  'Trending Content': 'Trending Content',
  'Trending Keywords: {A}': 'Trending Keywords: {A}',
  'Trending Posts': 'Trending Posts',
  'Trending Publications': 'Trending Publications',
  'Trending Videos': 'Trending Videos',
  'Trending Videos & Posts': 'Trending Videos & Posts',
  Trends: 'Trends',
  'Trends Analysis': 'Trends Analysis',
  'Trends in Views': 'Trends in Views',
  'Trends of Total Heat': 'Trends of Total Heat',
  Tuesday: 'Tuesday',
  'Tutorial-Core Functionality Display': 'Tutorial-Core Functionality Display',
  'Twitch Streaming': 'Twitch Streaming',
  'Twitch Streaming（Live Today）': 'Twitch Streaming（Live Today）',
  'Twitch Viewers': 'Twitch Viewers',
  Type: 'Type',
  'Type & Element': 'Type & Element',
  'Type & Elements': 'Type & Elements',
  'Type of Coverage': 'Type of Coverage',
  'Type the text to match the original, English, and Chinese translations of the comments.':
    'Type the text to match the original, English, and Chinese translations of the comments.',
  'Typed text will use precise matching search in preference.':
    'Typed text will use precise matching search in preference.',
  'UGC Trends': 'UGC Trends',
  URL: 'URL',
  'URL Analysis': 'URL Analysis',
  UV: 'UV',
  'Unable to generate a summary.': 'Unable to generate a summary.',
  'Unable to generate content summary due to source website restrictions or API instability, Please {btn}':
    'Unable to generate content summary due to source website restrictions or API instability, Please {btn}',
  'Unable to parse the link. Please ensure the link format is correct and reload the page.':
    'Unable to parse the link. Please ensure the link format is correct and reload the page.',
  'Unable to recognize the link': 'Unable to recognize the link',
  'Unable to scrape subtitles from this URL': 'Unable to scrape subtitles from this URL',
  'Unable to scrape the live stream comment from this URL': 'Unable to scrape the live stream comment from this URL',
  'Under the current selected time frame and official account, there is no data for the corresponding stream sessions. You may need to change other filtering conditions.':
    'Under the current selected time frame and official account, there is no data for the corresponding stream sessions. You may need to change other filtering conditions.',
  Unhealthy: 'Unhealthy',
  'Unidentified -1 ': 'Unidentified',
  'Unidentified -2': 'Unidentified',
  'Unidentified -3': 'Unidentified',
  'Unidentified -4': 'Unidentified',
  'Unidentified Mentions -1': 'Unidentified Mentions',
  'Unidentified Mentions -2': 'Unidentified Mentions',
  'Unidentified News Mentions': 'Unidentified News Mentions',
  Units: 'Units',
  Unknown: 'Unknown',
  'Unofficial Accounts': 'Unofficial Accounts',
  'Unrecognized Link': 'Unrecognized Link',
  Unreleased: 'Unreleased',
  Unscored: 'Unscored',
  Unsubscribe: 'Unsubscribe',
  'Unsubscribe failure': 'Unsubscribe failure',
  'Unsubscribe from AI Summary Emails': 'Unsubscribe from AI Summary Emails',
  'Unsubscribe from AI Summary Notifications on WeCom': 'Unsubscribe from AI Summary Notifications on WeCom',
  'Unsubscribe successful.': 'Unsubscribe successful.',
  'Up to': 'Up to',
  'Up to 5': 'Up to 5',
  'Up to 50 settings can be saved': 'Up to 50 settings can be saved',
  'Up to Current Hour': 'Up to Current Hour',
  'Up to Last Hour': 'Up to Last Hour',
  'Up to {num} games can be selected': 'Up to {num} games can be selected',
  'Update Frequency': 'Update Frequency',
  'Update Time: {time} (UTC+{timezone})': 'Update Time: {time} (UTC+{timezone})',
  'Update Title': 'Update Title',
  'Update {time} min ago': 'Update {time} min ago',
  'Use the original and multiple language translations text of the typed text to match the original, English and Chinese translations of the comments.':
    'Use the original and multiple language translations text of the typed text to match the original, English and Chinese translations of the comments.',
  'User Reviews': 'User Reviews',
  'User Score': 'User Score',
  'User Score Change%': 'User Score Change%',
  "User Score includes: Steam All Reviews Positive%、Steam Selected Reviews Positive%、OpenCritic Score、MetaCritic Score, etc. And the lifetime OpenCritic Score、MetaCritic Score cannot be split by language as they are directly scraped from the website's score.":
    "User Score includes: Steam All Reviews Positive%、Steam Selected Reviews Positive%、OpenCritic Score、MetaCritic Score, etc. And the lifetime OpenCritic Score、MetaCritic Score cannot be split by language as they are directly scraped from the website's score.",
  'User Score: Change(%)': 'User Score: Change(%)',
  'User Scores by language are not supported': 'User Scores by language are not supported',
  'User manually stopped the task.': 'User manually stopped the task.',
  Userscore: 'Userscore',
  'Vaildation Editing': 'Vaildation Editing',
  'Vaildation Editing': 'Vaildation Editing',
  'Valid Reviews': 'Valid Reviews',
  Validation: 'Validation',
  'Validation Criteria': 'Validation Criteria',
  'Value Only': 'Value Only',
  Variety: 'Variety',
  Verb: 'Verb',
  Version: 'Version',
  'Version Analysis': 'Version Analysis',
  'Version Name': 'Version Name',
  'Version Performance': 'Version Performance',
  'Version Selection': 'Version Selection',
  'Very Healthy': 'Very Healthy',
  'Very Negative': 'Very Negative',
  'Very Positive': 'Very Positive',
  'Very Unhealthy': 'Very Unhealthy',
  Video: 'Video',
  'Video (Sort by Date)': 'Video (Sort by Date)',
  'Video AI Tags': 'Video AI Tags',
  'Video Category': 'Video Category',
  'Video Comments': 'Video Comments',
  'Video Content Summary': 'Video Content Summary',
  'Video Count': 'Video Count',
  'Video Counts': 'Video Counts',
  'Video Duration': 'Video Duration',
  'Video Engagement': 'Video Engagement',
  'Video Engagement: Summary of Likes, Comments and Shares of all Videos.':
    'Video Engagement: Summary of Likes, Comments and Shares of all Videos.',
  'Video Engagements': 'Video Engagements',
  'Video Influencers': 'Video Influencers',
  'Video Likes': 'Video Likes',
  'Video Metrics': 'Video Metrics',
  'Video Prompt Modification': 'Video Prompt Modification',
  'Video Publications': 'Video Publications',
  'Video Share': 'Share',
  'Video Tag': 'Video Tag',
  'Video Tag Analysis': 'Video Tag Analysis',
  'Video Tag Insight': 'Video Tag Insight',
  'Video Titles': 'Video Titles',
  'Video Titles-1': 'Video Titles',
  'Video Trends': 'Video Trends',
  'Video Views': 'Video Views',
  'Video(Sort by Date)': 'Video(Sort by Date)',
  'Video/Post': 'Video/Post',
  Videos: 'Videos',
  'Videos & Posts': 'Videos & Posts',
  'Videos (Sort by Date)': 'Videos (Sort by Date)',
  'Videos (Top 5)': 'Videos (Top 5)',
  'Videos Sort by {value}': 'Videos Sort by {value}',
  'Videos-2': 'Videos',
  View: 'View',
  'View AI Summary': 'View AI Summary',
  'View All': 'View All',
  'View Comment Details': 'View Comment Details',
  'View Details': 'View Details',
  'View Feeds details for each social media platform, game store, and news channel.':
    'View Feeds details for each social media platform, game store, and news channel.',
  'View KOL Quotes': 'View KOL Quotes',
  'View Link': 'View Link',
  'View More': 'View More',
  'View Per Post': 'View Per Post',
  'View Per Publication': 'View Per Publication',
  'View Per Video': 'View Per Video',
  'View Prompt': 'View Prompt',
  'View Related Original Comments': 'View Related Original Comments',
  'View details': 'View details',
  'View list': 'View list',
  'View only first-time Top 100 hashtags': 'View only first-time Top 100 hashtags',
  'View only first-time Top 200 hashtags': 'View only first-time Top 200 hashtags',
  "View the game's KPIs performing": "View the game's KPIs performing",
  'View the mentions ratio by topic and the keywords in the word cloud.':
    'View the mentions ratio by topic and the keywords in the word cloud.',
  'View the mentions ratio by topic, and the keywords through the word cloud.':
    'View the mentions ratio by topic, and the keywords through the word cloud.',
  'View the mentions ratio by topic. Click on a single topic and view the keywords of the topic through the word cloud on the right.':
    'View the mentions ratio by topic. Click on a single topic and view the keywords of the topic through the word cloud on the right.',
  Viewers: 'Viewers',
  Views: 'Views',
  'Views (Top 5)': 'Views (Top 5)',
  'Views-1': 'Views',
  'Views-2': 'Views',
  'Visit original site': 'Visit original site',
  'Voice Reporting Text Analysis': 'Voice Reporting Text Analysis',
  Votes: 'Votes',
  WAU: 'WAU',
  "We couldn't generate the AI summary for this content. Please contact {contact} for help.":
    "We couldn't generate the AI summary for this content. Please contact {contact} for help.",
  'We couldn’t generate the AI summary for this content. Please contact sophiaxwxu@tencent.com for help.':
    'We couldn’t generate the AI summary for this content. Please contact sophiaxwxu@tencent.com for help.',
  'We recommend language filter. Region filter only fits some official accounts and creators.':
    'We recommend language filter. Region filter only fits some official accounts and creators.',
  Wednesday: 'Wednesday',
  Week: 'Week',
  Weekly: 'Weekly',
  'Weekly Avg. DAU': 'Avg. DAU',
  'Weekly Avg. Download': 'Avg. Downloads',
  'Weekly Tracking of Channel Ranking': 'Weekly Tracking of Channel Ranking',
  'Weekly Tracking of Key Metrics': 'Weekly Tracking of Key Metrics',
  "What it's about. <Exclude> Unwanted Content": "What it's about. <Exclude> Unwanted Content",
  'When defining a topic, follow the logic of "[{topic_name}] + [{text}] + [{text1}]" to help the system identify more accurately.':
    'When defining a topic, follow the logic of "[{topic_name}] + [{text}] + [{text1}]" to help the system identify more accurately.',
  'When too many events are selected, some may not be fully displayed on the chart due to space constraints. To view all the events, hover your mouse over the numbers below the axis.':
    'When too many events are selected, some may not be fully displayed on the chart due to space constraints. To view all the events, hover your mouse over the numbers below the axis.',
  'White Paper': 'White Paper',
  'Whole Sentence Sentiment': 'Whole Sentence Sentiment',
  'Why Hot': 'Why Hot',
  "Within the selected date range, DataBrain take the Region/Country's latest User Score, and then average the scores of these different Regions/Countries.":
    "Within the selected date range, DataBrain take the Region/Country's latest User Score, and then average the scores of these different Regions/Countries.",
  "Within the selected date range, DataBrain take the Region/Country's latest User Score, and then average the scores of these different Regions/Countries. (Excluding countries that lack Lifetime User Score on this day; Filters other than country and date do not take effect)\nThe countries displayed in Google Play reviews are obtained by crawling through the Google Play scores for each language and then mapping the language to the country.\nClick to see the National Language Mapping rule >":
    "Within the selected date range, DataBrain take the Region/Country's latest User Score, and then average the scores of these different Regions/Countries. (Excluding countries that lack Lifetime User Score on this day; Filters other than country and date do not take effect)\nThe countries displayed in Google Play reviews are obtained by crawling through the Google Play scores for each language and then mapping the language to the country.\nClick to see the National Language Mapping rule >",
  WoW: 'WoW',
  'Word Cloud chart': 'Word Cloud chart',
  Words: 'Words',
  'X Trends': 'X Trends',
  'X-axis = Mentions': 'X-axis = Mentions',
  'Y-axis = Average Engagement (Mentions / Engagements)': 'Y-axis = Average Engagement (Mentions / Engagements)',
  Year: 'Year',
  'Year to Date': 'Year to Date',
  Yes: 'Yes',
  Yesterday: 'Yesterday',
  'You are unable to view the game data currently, please feel free to contact {contact} for permissions.':
    'You are unable to view the game data currently, please feel free to contact {contact} for permissions.',
  'You can choose up to 9 games': 'You can choose up to 9 games',
  'You can go to [{name}] to create a new report, and it will automatically update based on your selected schedule.':
    'You can go to [{name}] to create a new report, and it will automatically update based on your selected schedule.',
  'You can go to the [{Configuration}] to add a new weekly report.':
    'You can go to the [{Configuration}] to add a new weekly report.',
  "You can provide some suggestions or other reports you'd like to subscribe to.":
    "You can provide some suggestions or other reports you'd like to subscribe to.",
  'You can switch the game in the side menu, or enter the main page of competitors from the competitor module.':
    'You can switch the game in the side menu, or enter the main page of competitors from the competitor module.',
  'You can view the analysis in the “{text}”.': 'You can view the analysis in the “{text}”.',
  'You can view the details of all opinions data sources and the detailed definitions of all opinions metrics in the Opinions system.':
    'You can view the details of all opinions data sources and the detailed definitions of all opinions metrics in the Opinions system.',
  'You can visit the [{name}] to experience AI Summary feature.':
    'You can visit the [{name}] to experience AI Summary feature.',
  'You can visit the [{name}] to experience AI Summary, Keyword Analysis, and URL Analysis features.':
    'You can visit the [{name}] to experience AI Summary, Keyword Analysis, and URL Analysis features.',
  'You haven’t saved this content. It will be lost if you confirm.':
    'You haven’t saved this content. It will be lost if you confirm.',
  'You will no longer receive any WeCom notifications related to the AI Summary. If you wish to re-enable this WeCom notification service, please contact: {email}.':
    'You will no longer receive any WeCom notifications related to the AI Summary. If you wish to re-enable this WeCom notification service, please contact: {email}.',
  'You will no longer receive any email notifications related to the AI Summary. If you wish to re-enable this email notification service, please contact: {email}.':
    'You will no longer receive any email notifications related to the AI Summary. If you wish to re-enable this email notification service, please contact: {email}.',
  'YouTube shorts': 'YouTube shorts',
  '[Custom AI Summary]': '[Custom AI Summary]',
  '[Saved Analysis List]': '[Saved Analysis List]',
  '[Summary List]': '[Summary List]',
  and: 'and',
  'and statistically analyzed by language detection': 'and statistically analyzed by language detection',
  'by Account': 'by Account',
  'by DataBrain Crawling': 'by DataBrain Crawling',
  'by External Data Sources': 'by External Data Sources',
  'by Game Store': 'by Game Store',
  'by Keyword': 'by Keyword',
  'by Steam Homepage': 'by Steam Homepage',
  'by {name}': 'by {name}',
  'click to view the latest data': 'click to view the latest data',
  'click to view the latest data.': 'click to view the latest data.',
  common: 'Common Publisher',
  'data.ai DAU': 'data.ai DAU',
  'data.ai Download': 'data.ai Download',
  'data.ai MAU': 'data.ai MAU',
  'data.ai Revenue': 'data.ai Revenue',
  'data.ai WAU': 'data.ai WAU',
  day: 'day',
  days: 'days',
  'download Original Comments': 'download Original Comments',
  'events-1': 'events',
  feedback: 'Feedback',
  fold: 'fold',
  "from the game's release on Steam to {time}": "from the game's release on Steam to {time}",
  hour: 'hour',
  hours: 'hours',
  'it requires 0.5~1 hours to complete.': 'it requires 0.5~1 hours to complete.',
  'items in total': 'items in total',
  keyWords: 'Keyword',
  'last 30 days up to {time}': 'last 30 days up to {time}',
  'live stream comment': 'live stream comment',
  macro: 'Macro',
  mega: 'Mega',
  micro: 'Micro',
  'mid-tier': 'Mid-Tier',
  'module-1': 'Module',
  month: 'month',
  months: 'months',
  nano: 'Nano',
  negative: 'negative',
  neutral: 'neutral',
  or: 'or',
  'out of {total} Engagement': 'out of {total} Engagement',
  'out of {total} Reviews': 'out of {total} Reviews',
  'out of {total} Steam Reviews': 'out of {total} Steam Reviews',
  page: 'page',
  pages: 'pages',
  positive: 'positive',
  refresh: 'refresh',
  'reviews are selected, including': 'reviews are selected, including',
  'show all': 'show all',
  'sorry, no result found.': 'sorry, no result found.',
  subtitle: 'subtitle',
  'the Compare page': 'the Compare page',
  to: 'to',
  'version-1': 'Version',
  week: 'week',
  weeks: 'weeks',
  'with statistics generated based on filters': 'with statistics generated based on filters',
  '{count} comment have been crawled.': '{count} comment have been crawled.',
  '{count} comments have been crawled.': '{count} comments have been crawled.',
  '{count} review is selected, including': '{count} review is selected, including',
  '{count} reviews are selected, including': '{count} reviews are selected, including',
  '{language} All Reviews': '{language} All Reviews',
  '{language} All Reviews/Total': '{language} All Reviews/Total',
  '{record_duration} hrs on record': '{record_duration} hrs on record',
  '{record_duration} hrs on record ({review_duration} hrs at review time)':
    '{record_duration} hrs on record ({review_duration} hrs at review time)',
  '{review_duration} hrs at review time': '{review_duration} hrs at review time',
  '{total} Reviews are included': '{total} Reviews are included',
  '“Recent Reviews” refer to reviews from the past 30 days. Therefore, data is only available starting from the 31st day after launch.':
    '“Recent Reviews” refer to reviews from the past 30 days. Therefore, data is only available starting from the 31st day after launch.',
  '↑ Increase ↓ Decrease': '↑ Increase ↓ Decrease',
  '≤ Less than or equal': '≤ Less than or equal',
  '≥ Greater than or equal to': '≥ Greater than or equal to',
  '《Opinions Game》': '《Opinions Game》',
  参数校验错误: 'Parameter error',
  系统错误: 'System error',
};
